import { Component, OnInit, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { CandidateDetails } from '../../models/candidate';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Inject, OnDestroy } from '@angular/core';
import { ProfileService } from '../../services/profile.service';
import { DynamicCandidateProfileComponent } from '../../components/dynamic-candidate-profile/dynamic-candidate-profile.component';
import { DynamicCandidateProfileService, Candprofile } from '../../services/dynamic-candidate-profile.service';
import { GenModel1, Experience, Options } from 'src/app/shared/models/candidateprofile-genmodel';
// import { DynamicFormComponent } from 'src/app/shared/components/dynamic-form/dynamic-form.component';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { PersonaService } from 'src/app/core/services/persona.service';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ActivityService } from '../../../core/services/activity.service';
import moment from 'moment';
import { FileDownloadService } from '../../services/file-download.service';

@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.scss'],
  standalone: false,
})
export class ViewProfileComponent implements OnInit, OnDestroy {
  formvalue: UntypedFormGroup;
  @ViewChild('candidate') dynamicFormComponent: DynamicCandidateProfileComponent;
  @ViewChildren('edu') education: QueryList<DynamicCandidateProfileComponent>;
  @ViewChildren('experience') workexperience: QueryList<DynamicCandidateProfileComponent>;
  @ViewChildren('address') canAddress: QueryList<DynamicCandidateProfileComponent>;
  @ViewChildren('comps') compensation: QueryList<DynamicCandidateProfileComponent>;
  @ViewChildren('gaps') eduExpgaps: QueryList<DynamicCandidateProfileComponent>;
  @ViewChildren('attach') attachment: QueryList<DynamicCandidateProfileComponent>;

  // @ViewChild('linkRef0', { static: false }) dynamicedu0:ElementRef;
  // @ViewChild('linkRef1', { static: false }) dynamicedu1:ElementRef;
  // @ViewChild("edu0", { static: false }) educationRef: DynamicFormComponent;
  candprofile: Candprofile;
  genmodel: GenModel1;
  degreeNameList: string[] = [];
  basicInfoForm: any;
  educationForm: object[] = [];
  experienceForm: object[] = [];
  addressForm: object[] = [];
  loginUserName: string;
  // dynamicedu: ElementRef[] = new Array(this.genmodel.educations.length)
  isEdit: boolean = false;
  candidateDetails: CandidateDetails;
  educationFormInvalid: boolean = false;
  skillList: any;
  newSkillId: number;
  loginEmpNo: any;
  exEmployeeNo;
  data1 = {
    // Required
    type: 'view-profile component', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '5', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };
  inOffer = false;
  companyHiringType: number = parseInt(localStorage.getItem('fresherCompHiringTypeId'));
  expFormInvalid: boolean = false;
  addressFormInvalid: boolean = false;
  genDefault: Experience[];
  OriginalGenModel: GenModel1;
  eduBool: boolean = false;
  expBool: boolean = false;
  addrBool: boolean = false;
  compensationForm: any[];
  expgapsForm: any[];
  edugapsForm: any[];
  compensationLabels: any = [];
  wrapperObject: any;
  checkApp: boolean;
  // countrycode: any;
  // countrycode2: any;
  // countrycode3: any;
  //eduAttach variables
  XPostGradList: string[] = ['Degree Certificate', 'Mark Sheet'];
  semesterList: string[] = [
    'Degree Certificate',
    'Provisional Certificate',
    'Year1',
    'Year2',
    'Year3',
    'Year4',
    'Year5',
    'Semester1',
    'Semester2',
    'Semester3',
    'Semester4',
    'Semester5',
    'Semester6',
    'Semester7',
    'Semester8',
    'Semester9',
    'Semester10',
  ];
  marksWiseList: string[] = ['Degree Certificate', 'Provisional Certificate', 'Consolidated Marksheet'];

  // X attachmentIds
  XAttachmentIds: any[] = [6, 7];
  // XII attachmentIds
  XIIMarksAttachIds: any[] = [8, 9];
  //grad attachmentIds
  gradSemAttachIds: any[] = [28, 29, 31, 32, 33, 34, 35, 36, 37, 38, 39, 60, 61, 62, 63, 64, 65];
  gradConsAttachIds: any[] = [28, 29, 30];
  //postgrad attachmentIds
  postgradSemAttachIds: any[] = [66, 67, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83];
  postgradConsAttachIds: any[] = [66, 67, 68];
  //postgrad attachmentIds
  diplomaSemAttachIds: any[] = [10, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27];
  diplomaConsAttachIds: any[] = [10, 11, 12];

  dispAttach: any;
  showAttach = false;
  uploadType: string = 'S';
  semWise: boolean = true;
  consMark: boolean = false;
  attachmentsList: any;
  fileMergeAttach: any = [];
  eduAttachsIds: any;
  eduAtchIndex: any;
  //expAttach variables
  noCurrentEmp = ['Experience Letter', 'Relieving Letter', 'Offer Letter'];
  currentEmp = [
    'Offer Letter',
    'Salary Revision Letter',
    'Salary slip month1',
    'Salary slip month2',
    'Salary slip month3',
  ];
  noCurrentEmpId = [40, 41, 42];
  currentEmpId = [42, 46, 43, 44, 45];
  eduExpVar: any;
  attachmentsExpList: any;
  candidateExpId: any;
  targetIndex: number = 0;
  instituteOptions: Options[] = [];
  universityOptions: Options[] = [];
  saveEduDisable = false;
  saveExpDisable = false;
  saveAttachDisable = false;
  resObj: any;
  obj: any;
  lpdisable = false;
  saved: boolean = false;
  saveDocId: boolean = false;
  constructor(
    private _telemetryServices: TelemetryServices,
    private profile: ProfileService,
    private dialogRef: MatDialogRef<ViewProfileComponent>,
    private apiData: DynamicCandidateProfileService,
    public dialog: MatDialog,
    private eRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _personaService: PersonaService,
    private http: HttpClient,
    private datePipe: DatePipe,
    @Inject(NgxUiLoaderService) private ngxLoader: NgxUiLoaderService,
    public confirmDialog: MatDialog,
    private activityService: ActivityService,
    private fileDownloadService: FileDownloadService
  ) {}
  OnClose(): void {
    this.dialogRef.close(this.exEmployeeNo);

    // telemtry interact call

    this.data1.subtype = 'icon-click';
    this.data1.itype = 'on close icon-click';
    this.data1.stageto = 'closing of view-profile component';
    if (this.data1) {
      // this._telemetryServices.telemetryInteract(this.data1);
    }
  }

  // getProfile() {
  //   this.profile.getProfile().subscribe((data) => {
  //     console.log(data);
  //     this.candidateDetails = data;
  //   })
  // }

  ngOnInit() {
    // telemtry  API CALL and, send data
    if (this.companyHiringType == 9) {
      this.noCurrentEmp = ['Latest Payslip', 'Certificate of Employment', 'Clearance Form'];
      this.currentEmp = ['Certificate of Employment', 'Resignation Letter', 'Latest Payslip', 'Clearance Form'];
      this.noCurrentEmpId = [43, 48, 55];
      this.currentEmpId = [48, 41, 43, 55];
    }

    if (window.location.href.includes('offer')) {
      this.inOffer = true;
    }
    this.data1.subtype = 'view-profile';
    this.data1.itype = 'clciking on view profile';
    this.data1.stageto = 'view-profile loading';
    if (this.data1) {
      // this._telemetryServices.telemetryImpression(this.data1);
    }

    // this.getProfile();
    // console.log(this.getProfile());
    this.candprofile = {
      screenName: this.data.screenName,
      candidateId: this.data.candidateId,
      applicationId: this.data.applicationId,
      companyHiringTypeId: this.companyHiringType,
    };
    // console.log(this.apiData.getApiData());
    // this.genmodel =this.apiData.getApiData();
    this.getGenModel();
    this.checkApplication(this.data.applicationId);
    this._personaService.getLoggedUserDetails().subscribe(
      (res) => {
        if (res) {
          this.loginUserName = res.empName;
          this.loginEmpNo = res.empNo;
        }
      },
      (err) => {
        console.log('error', err.status);
      },
    );
  }

  regenerate() {
    const message = 'Are you sure you want to Regenerate HR Form ?';
    const dialogData = new ConfirmDialogModel(message, '');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.activityService
          .regenerateHRchecklist(this.candprofile.applicationId, this.candprofile.candidateId)
          .subscribe(
            (_res) => {
              this._personaService.openSnackBar(
                { msg: 'Hr Form Regenerated Successfully', isSuccess: true },
                'success-snack',
              );
            },
            (_err) => {},
          );
      }
    });
  }
  profileEdit: boolean = true;
  roleCheck: boolean = false;
  infyProfileEdit: boolean = false;
  ScsMsg: string = 'Saved Successfully';
  ScsMsgHr: string = 'Saved Successfully, Please generate HR form to see updated details';
  checkDb(role, res) {
    if (role === 'DB Admin' || role === 'DB Associate') {
      this.infyProfileEdit = res.isHrChecklistDone == 'Y' ? true : false;
      return false;
    } else {
      return res.isHrChecklistDone == 'Y' ? true : false;
    }
  }
  getGenModel() {
    this.apiData.getdata(this.candprofile).subscribe((res) => {
      const role = localStorage.getItem('role');
      const CompanyHiringType = localStorage.getItem('fresherCompHiringTypeId');
      if (CompanyHiringType == '1') {
        this.activityService
          .getHRchecklistStatus(this.candprofile.applicationId, this.candprofile.candidateId)
          .subscribe(
            (res) => {
              if (res.isJoinedActivityDone == 'Y') {
                this.profileEdit = true;
                this.roleCheck = false;
              } else {
                this.profileEdit = role === 'Offer DEO' || role === 'Offer_Admin' ? false : this.checkDb(role, res);
                this.roleCheck = role === 'Offer DEO' || role === 'Offer_Admin' ? res.isHrChecklistDone == 'Y' : false;
              }
            },
            (err) => {
              console.log(err);
              this.profileEdit = false;
              this.roleCheck = false;
            },
          );
      } else {
        this.profileEdit = false;
        this.roleCheck = false;
      }
      this.OriginalGenModel = JSON.parse(JSON.stringify(res));

      if (res.address) {
        const genRes = res.address.filter((adFields) => {
          let count = 0;
          adFields.fields.forEach((field) => {
            if (field.value == null) {
              count++;
            }
          });
          if (count != adFields.fields.length) {
            return adFields;
          }
        });
        res.address = genRes;
      }

      if (res.educations) {
        const eduRes = res.educations.filter((adFields) => {
          let count = 0;
          adFields.fields.forEach((field) => {
            if (field.value == null) {
              count++;
            }
          });
          if (count != adFields.fields.length) {
            return adFields;
          }
        });
        res.educations = eduRes;
      }

      if (res.experience) {
        const expRes = res.experience.filter((adFields) => {
          let count = 0;
          adFields.fields.forEach((field) => {
            if (field.value == null) {
              count++;
            }
          });
          if (count != adFields.fields.length) {
            return adFields;
          }
        });
        res.experience = expRes;
      }

      if (
        (this.companyHiringType == 1 || this.companyHiringType == 4) &&
        (localStorage.getItem('roleCode') === 'DBAD' || localStorage.getItem('roleCode') === 'DBAS')
      ) {
        this.obj = res.fields.find((obj) => obj.name == 'employeeNo' || obj.name == 'subconId');
        if (this.obj.type != 0 && this.obj.value != 'NA') {
          const index = res.fields.indexOf(this.obj);
          res.fields[index].type = 0;
        }
      } else {
        for (let i = 0; i < res.fields.length; i++) {
          if ((res.fields[i].name == 'employeeNo' || res.fields[i].name == 'subconId') && res.fields[i].type == 0) {
            res.fields[i].type = 14;
          }
        }
      }
      if (res.gaps) {
        const gapsRes = res.gaps.filter((adFields) => {
          let count = 0;
          adFields.fields.forEach((field) => {
            if (field.value == null) {
              count++;
            }
          });
          if (count != adFields.fields.length) {
            return adFields;
          }
        });
        res.gaps = gapsRes;
      }
      if (res.compensation) {
        const compRes = res.compensation.filter((adFields) => {
          let count = 0;
          adFields.fields.forEach((field) => {
            if (field.value == null) {
              count++;
            }
          });
          if (count != adFields.fields.length) {
            return adFields;
          }
        });
        if (compRes.length == 0) {
          res.compensation = compRes;
        }
      }

      if (res.attachments) {
        const attchRes = res.attachments.filter((adFields) => {
          let count = 0;
          adFields.fields.forEach((field) => {
            if (field.value == null) {
              count++;
            }
          });
          if (count != adFields.fields.length) {
            return adFields;
          }
        });
        res.attachments = attchRes;
        this.attachmentsList = JSON.parse(JSON.stringify(res.attachments));

        if (this.companyHiringType == 4 || this.companyHiringType == 5) {
          const xAttach_ = res.attachments.filter((eleVp_) => {
            const attachIdVp_ = eleVp_.fields.find((field) => field.name === 'attachmentType').options[0].key;
            if (!(
              this.XAttachmentIds.indexOf(attachIdVp_) != -1 ||
              this.XIIMarksAttachIds.indexOf(attachIdVp_) != -1 ||
              this.gradSemAttachIds.indexOf(attachIdVp_) != -1 ||
              this.gradConsAttachIds.indexOf(attachIdVp_) != -1 ||
              this.postgradSemAttachIds.indexOf(attachIdVp_) != -1 ||
              this.postgradConsAttachIds.indexOf(attachIdVp_) != -1 ||
              this.diplomaSemAttachIds.indexOf(attachIdVp_) != -1 ||
              this.diplomaConsAttachIds.indexOf(attachIdVp_) != -1
            )) {
              return eleVp_;
            }
          });
          res.attachments = xAttach_;
        }
      }

      this.genmodel = <GenModel1>res;
      this.genmodel = res;
      //phonenumber change
      // this.genmodel.fields[7].type=25;
      // this.genmodel.fields[8].type=25;
      // this.genmodel.fields[15].type=25;
      // this.genmodel.fields[7].value="+11-7656789876";
      // this.genmodel.fields[8].value="+12-9656789876";
      // this.genmodel.fields[15].value="+13-87656789876";
    });
  }
  iseditable() {
    console.log(this.OriginalGenModel);
    this.isEdit = !this.isEdit;

    //getting all Institues and Universities dropdown list
    // let instUrl = this.OriginalGenModel.educations[(this.OriginalGenModel.educations.length)-1].fields.find(fieldName => fieldName.name == 'institute').url;
    // this.http.get<any>(instUrl).subscribe(res => {
    //   if (res) {
    //     let temp = [];
    //     res.forEach((val, key) => {
    //       temp.push({ key: val['instituteId'], value: val['instituteName'] });
    //     })
    //     this.instituteOptions = <Options[]>temp;
    //     this.genmodel.educations.forEach(ele=>{
    //       ele.fields.find(fieldName => fieldName.name == 'institute').options = this.instituteOptions;
    //     })
    //   }
    // })

    const univUrl = this.OriginalGenModel.educations[this.OriginalGenModel.educations.length - 1].fields.find(
      (fieldName) => fieldName.name == 'universityName',
    ).url;
    console.log(univUrl);
    this.http.get<any>(univUrl).subscribe((res) => {
      if (res) {
        const temp = [];
        res.forEach((val, _key) => {
          temp.push({ key: val['universityCode'], value: val['universityName'] });
        });
        this.universityOptions = <Options[]>temp;
        this.genmodel.educations.forEach((ele) => {
          ele.fields.find((fieldName) => fieldName.name == 'universityName').options = this.universityOptions;
        });
      }
    });
    console.log(this.OriginalGenModel);
    // telemtry interact call

    this.data1.subtype = 'view-profile';
    this.data1.itype = 'editing of fields';
    this.data1.stageto = 'selecting the fields for editing';
    if (this.data1) {
      // this._telemetryServices.telemetryInteract(this.data1);
    }
    console.log(this.OriginalGenModel);
  }

  submit() {
    console.log(this.dynamicFormComponent.value);

    let basicinfoForm = this.genmodel.fields ? this.getSaveBasic() : null;
    if (this.genmodel.fields && basicinfoForm == null) { return; }

    let expVar = this.getSaveExperience();
    if (expVar == null) { return; }

    let addrVar = this.getSaveAddress();
    if (addrVar == null) { return; }

    let saveGap = this.getSaveGaps();
    let saveCompObj = this.getSaveCompensation();
    let eduVar = this.getSaveEducation();
    if (saveGap == null || saveCompObj == null || eduVar == null) { return; }

    const combinedPayload: any = {
      "candidateExpDetail": expVar,
      "candidateAddressDetails": addrVar,
      "candidateEducationDetail": eduVar,
      "candidateEdGapDetail": {
        "candidateEmail": this.dynamicFormComponent.form.get('emailId').value,
        "candidateId": this.data.candidateId,
        "gaps": this.edugapsForm,
        "gapType": "ED"
      },
      "candidateExpGapDetail": {
        "candidateEmail": this.dynamicFormComponent.form.get('emailId').value,
        "candidateId": this.data.candidateId,
        "gaps": this.expgapsForm,
        "gapType": "EXP"
      },
      "candidateCnbDetail": this.compensationForm,
      "action": "save"
    };

    if (basicinfoForm) {
      const { exEmployeeNo, newSkillId, totalYearsOfExperience, country_code:_country_code, country_code2:_country_code2, country_code3:_country_code3, applicationId:_applicationId, ...restBasicForm } = basicinfoForm;
      combinedPayload["candidateBasicDetail"] = {
        ...restBasicForm,
        "exEmployeeNum": exEmployeeNo || null,
        "skillIdsList": newSkillId || [],
        "totalMonthsOfExperience": totalYearsOfExperience || null
      };
    }

    this.saveAttachment('submit');
    this.apiData.editGapsInfo(combinedPayload).subscribe(res => {
      console.log(res);
      this._personaService.openSnackBar({ msg: this.roleCheck ? this.ScsMsgHr : this.ScsMsg, isSuccess: true }, 'success-snack');
      this.getGenModel();
      this.OnClose();
    });

    // telemtry interact call

    this.data1.subtype = 'button click';
    this.data1.itype = 'clicking of submit button';
    this.data1.stageto = 'on submitting the form';
    if (this.data1) {
      // this._telemetryServices.telemetryInteract(this.data1);
    }
  }
  selectedActivity() {
    const listActivities = [600103, 600303, 600304];
    if (
      this.activityService.lastActivityPerformed &&
      listActivities.includes(this.activityService.lastActivityPerformed.activityid) &&
      ((localStorage.getItem('role') === 'Recruiter' &&
        (localStorage.getItem('fresherCompHiringTypeId') === '4' ||
          localStorage.getItem('fresherCompHiringTypeId') === '2')) ||
        (localStorage.getItem('role') === 'Offer_Admin' && localStorage.getItem('fresherCompHiringTypeId') === '1'))
    ) {
      return true;
    } else {
      return false;
    }
  }

  lpPushbutton() {
    if (this.selectedActivity()) {
      const messageReject = 'Are you sure you want to push data to LP?';
      const dialogData = new ConfirmDialogModel(messageReject, '');
      const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
      dialogRef.afterClosed().subscribe((dialogResultReject) => {
        if (dialogResultReject) {
          const applicationId = this.data.applicationId;
          this.activityService.getCandidateOfferUpdate(applicationId).subscribe((Res) => {
            this.resObj = Res;
            const offerId = this.resObj.offerId;
            console.log('OFFER ID:', offerId);
            this.ngxLoader.start();
            this.activityService.launchpadOfferId(offerId).subscribe(
              (response) => {
                this._personaService.openSnackBar(
                  { msg: response['Launchpad Response'], isSuccess: true },
                  'success-snack',
                );
                this.lpdisable = true;
                this.ngxLoader.stop();
              },
              (err) => {
                let elsemsg = 'Data cannot be pushed to LP';
                if (err?.status == 500) {
                  const launchpadResp = err?.error['Launchpad Response'];

                  if (launchpadResp) {
                    try {
                      const jsonMatch = launchpadResp.match(/\{.*\}/s);
                      if (jsonMatch) {
                        const parsed = JSON.parse(jsonMatch[0]);
                        elsemsg = parsed.message || launchpadResp;
                      } else {
                        elsemsg = launchpadResp;
                      }
                    } catch {
                      elsemsg = launchpadResp;
                    }
                  }
                }

                this._personaService.openSnackBar({ msg: elsemsg, isSuccess: false }, 'danger-snack');
                this.ngxLoader.stop();
              },
            );
          });
        }
      });
    }
  }
  ngOnDestroy() {
    // telemtry end call

    this.data1.type = 'view profile component';
    this.data1.subtype = 'view profile cleanup stage/end of page';
    this.data1.pageid = '4';
    this.data1.itype = 'AUTO';
    this.data1.stageto = 'destroy component,initial page';
    if (this.data) {
      // this._telemetryServices.telemetryEnd(this.data1);
    }
  }

  saveBasicDetails() {
    const basicinfoForm = this.getSaveBasic();
    if (basicinfoForm != null) {
      console.log("basic form in savebasic--", basicinfoForm)
      const { exEmployeeNo, newSkillId, totalYearsOfExperience, country_code:_country_code, country_code2:_country_code2, country_code3:_country_code3, applicationId:_applicationId, ...restBasicForm } = basicinfoForm;
      const basicWrapperObj = {
        "candidateBasicDetail": {
          ...restBasicForm,
          "exEmployeeNum": exEmployeeNo || null,
          "skillIdsList": newSkillId || [],
          "totalMonthsOfExperience": totalYearsOfExperience || null
        },
        "action": "save"
      };
      this.apiData.editGapsInfo(basicWrapperObj).subscribe((res) => {
        console.log(res);
        this._personaService.openSnackBar({ msg: this.roleCheck? this.ScsMsgHr: this.ScsMsg, isSuccess: true }, 'success-snack');
      })
    }
  }

  addEducation() {
    this.eduBool = true;
    console.log('in add new education');
    // let newEdu = {...this.genmodel.educations[0]};
    // let newEdu = Object.assign({},this.genmodel.educations[0]);
    // let newEdu = JSON.parse(JSON.stringify(this.genmodel.educations[0]))
    this.genDefault = this.OriginalGenModel.educations.filter((adFields) => {
      let count = 0;
      adFields.fields.forEach((field) => {
        if (field.value == null) {
          count++;
        }
      });
      if (count == adFields.fields.length) {
        return adFields;
      }
    });
    this.genDefault[0].fields.find((res) => res.name === 'degree').type = 10;
    this.genDefault[0].fields.find((res) => res.name === 'institute').options = this.instituteOptions;
    this.genDefault[0].fields.find((res) => res.name === 'universityName').options = this.universityOptions;
    const newEdu = JSON.parse(JSON.stringify(this.genDefault[0]));
    newEdu.degreeName = 'New Education';
    // newEdu.fields.forEach((eduField) => {
    //   eduField.value = null;
    //   if (eduField.options && eduField.options.length > 0) {
    //     eduField.options.forEach((eduOptions) => {
    //       eduOptions.selected = false;
    //     })
    //   }
    // })
    this.genmodel.educations.unshift(newEdu);
  }
  saveEducation() {
    console.log('in save edu');
    const saveEduObj = this.getSaveEducation();

    if (saveEduObj != null) {
      if (this.companyHiringType == 1) {
        const educationOverlap = this.hasEducationOverlap(saveEduObj);
        if (educationOverlap) {
          this._personaService.openSnackBar(
            {
              msg: `Education dates are overlapping between ${educationOverlap.candidateEducationType1} and ${educationOverlap.candidateEducationType2}`,
              isSuccess: false,
            },
            'danger-snack',
          );
          return;
        }
      }
      this.wrapperObject = {
        "candidateEducationDetail": saveEduObj,
        "action": "save"
      }
      this.saveEduDisable = true;
      this.apiData.editGapsInfo(this.wrapperObject).subscribe((res) => {
        console.log(res);
        this._personaService.openSnackBar(
          { msg: this.roleCheck ? this.ScsMsgHr : this.ScsMsg, isSuccess: true },
          'success-snack',
        );
        this.apiData.getdata(this.candprofile).subscribe((res) => {
          this.saveEduDisable = false;
          this.OriginalGenModel = JSON.parse(JSON.stringify(res));
          if (res.educations) {
            const eduRes = res.educations.filter((adFields) => {
              let count = 0;
              adFields.fields.forEach((field) => {
                if (field.value == null) {
                  count++;
                }
              });
              if (count != adFields.fields.length) {
                return adFields;
              }
            });
            eduRes.forEach((ins) => {
              ins.fields.find((fieldName) => fieldName.name == 'institute').options = this.instituteOptions;
              ins.fields.find((fieldName) => fieldName.name == 'universityName').options = this.universityOptions;
            });
            res.educations = eduRes;
          }
          if (this.genmodel) {
            this.genmodel.educations = res.educations;
          }
        });
      });
    }
  }

  removeEducation(index, educationObj) {
    const messageReject = 'Are you sure you want to delete this Education ?';
    const dialogData = new ConfirmDialogModel(messageReject, '');
    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
    dialogRef.afterClosed().subscribe((dialogResultReject) => {
      if (dialogResultReject) {
        const canEduId = educationObj.fields.find((ele) => {
          return ele.name == 'candidateEducationId';
        }).value;
        console.log('in remove edu', educationObj, canEduId);
        if (canEduId != null) {
          this.apiData.deleteEducation([canEduId]).subscribe((_res) => {
            this.genmodel.educations.splice(index, 1);
            this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
          });
        } else {
          this.genmodel.educations.splice(index, 1);
          this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
        }
      }
    });
  }

  addExperience() {
    console.log('in add new experience');
    this.expBool = true;
    // let newExp = {...this.genmodel.experience[0]};
    // let newExp = JSON.parse(JSON.stringify(this.genmodel.experience[0]))
    this.genDefault = this.OriginalGenModel.experience.filter((adFields) => {
      let count = 0;

      adFields.fields.forEach((field) => {
        if (field.value == null) {
          count++;
        }
      });
      if (count == adFields.fields.length) {
        return adFields;
      }
    });
    const newExp = JSON.parse(JSON.stringify(this.genDefault[0]));
    newExp.fields.forEach((expField) => {
      expField.value = null;
      if (expField.options && expField.options.length > 0) {
        expField.options.forEach((expOptions) => {
          expOptions.selected = false;
        });
      }
    });
    newExp['new'] = true;
    console.log(newExp);

    this.genmodel.experience.unshift(newExp);
  }

  saveExperience() {
    const saveExpObj = this.getSaveExperience();
    if (saveExpObj != null) {
      // check for overlapping dates
      if (this.companyHiringType == 1) {
        const overlapInfo = this.hasExperienceOverlap(saveExpObj);
        if (overlapInfo) {
          this._personaService.openSnackBar(
            {
              msg: `The work experience dates for ${overlapInfo.company1} and ${overlapInfo.company2} overlap. You may proceed by considering the experience from only one of the companies.`,
              isSuccess: false,
            },
            'danger-snack',
          );
          return;
        }
      }

      this.expBool = false;
      this.saveExpDisable = true;
      this.wrapperObject = {
        "candidateExpDetail": saveExpObj,
        "action": "save"
      }
      this.apiData.editGapsInfo(this.wrapperObject).subscribe((res) => {
        console.log(res);
        this._personaService.openSnackBar({ msg: this.roleCheck? this.ScsMsgHr: this.ScsMsg, isSuccess: true }, 'success-snack');

          this.apiData.getdata(this.candprofile).subscribe((res) => {
            this.saveExpDisable = false;
            this.OriginalGenModel = JSON.parse(JSON.stringify(res));
            if (res.experience) {
              const expRes = res.experience.filter((adFields) => {
                let count = 0;
                adFields.fields.forEach((field) => {
                  if (field.value == null) {
                    count++;
                  }
                });
                if (count != adFields.fields.length) {
                  return adFields;
                }
              });
              res.experience = expRes;
            }
            if (this.genmodel) {
              this.genmodel.experience = res.experience;
            }
          });
        },
        (_err) => {
          this._personaService.openSnackBar({ msg: 'save failed', isSuccess: 'error' }, 'danger-snack');
        },
      );
    }
    // let countExpTill = 0;
    // saveExpObj.forEach((exp) => {
    //   if (exp['tillDate'] == 'Y') {
    //     countExpTill++;
    //   }
    // })
    // if (countExpTill > 1) {
    //   this._personaService.openSnackBar({ msg: "Only one Current Employer Allowed", isSuccess: 'error' }, 'danger-snack');
    // }
    // else {
    //   this.apiData.editexperienceInfo(saveExpObj).subscribe((res) => {
    //     console.log(res);
    //     this._personaService.openSnackBar({ msg: "Saved Successfully", isSuccess: true }, 'success-snack');
    //     this.apiData.getdata(this.candprofile).subscribe(res => {
    //       this.OriginalGenModel = JSON.parse(JSON.stringify(res))
    //       if (res.experience) {
    //         let expRes = res.experience.filter((adFields) => {
    //           let count = 0;
    //           adFields.fields.forEach((field) => {
    //             if (field.value == null) {
    //               count++;
    //             }
    //           })
    //           if (count != adFields.fields.length) {
    //             return adFields
    //           }
    //         })
    //         res.experience = expRes;
    //       }
    //       this.genmodel.experience = res.experience;
    //     })
    //   })
    // }
  }

  removeExperience(index, expObj) {
    const messageReject = 'Are you sure you want to delete this Experience ?';
    const dialogData = new ConfirmDialogModel(messageReject, '');
    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
    dialogRef.afterClosed().subscribe((dialogResultReject) => {
      if (dialogResultReject) {
        const canExpId = expObj.fields.find((ele) => {
          return ele.name == 'candidateExperienceId';
        }).value;
        console.log('in remove exp', expObj, canExpId);
        if (canExpId != null) {
          this.apiData.deleteExperience([canExpId]).subscribe((_res) => {
            this.genmodel.experience.splice(index, 1);
            this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
          });
        } else {
          this.genmodel.experience.splice(index, 1);
          this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
        }
      }
    });
  }

  addAddress() {
    console.log('in add new experience');
    this.addrBool = true;
    // let newExp = {...this.genmodel.experience[0]};
    this.genDefault = this.OriginalGenModel.address.filter((adFields) => {
      let count = 0;
      adFields.fields.forEach((field) => {
        if (field.value == null) {
          count++;
        }
      });
      if (count == adFields.fields.length) {
        return adFields;
      }
    });
    const newAddress = JSON.parse(JSON.stringify(this.genDefault[0]));

    // let newAddress = JSON.parse(JSON.stringify(this.genmodel.address[0]))
    newAddress.fields.forEach((adrField) => {
      adrField.value = null;
      if (adrField.options && adrField.options.length > 0) {
        adrField.options.forEach((adrOptions) => {
          adrOptions.selected = false;
        });
      }
    });
    newAddress['new'] = true;
    this.genmodel.address.unshift(newAddress);
  }

  saveAddress() {
    const saveAddrObj = this.getSaveAddress();
    if (saveAddrObj != null) {
      this.addrBool = false;
      const addrWrapperObj = {
        "candidateAddressDetails": saveAddrObj,
        "action": "save"
      };
      this.apiData.editGapsInfo(addrWrapperObj).subscribe((result) => {
        console.log(result);
        this._personaService.openSnackBar(
          { msg: this.roleCheck ? this.ScsMsgHr : this.ScsMsg, isSuccess: true },
          'success-snack',
        );
        this.apiData.getdata(this.candprofile).subscribe((res1) => {
          this.OriginalGenModel = JSON.parse(JSON.stringify(res1));
          if (res1.address) {
            const genRes = res1.address.filter((adFields) => {
              let count = 0;
              adFields.fields.forEach((field) => {
                if (field.value == null) {
                  count++;
                }
              });
              if (count != adFields.fields.length) {
                return adFields;
              }
            });
            res1.address = genRes;
          }
          if (this.genmodel) {
            this.genmodel.address = res1.address;
          }
        });
      });
    }
  }

  removeAddress(index, addrObj) {
    const messageReject = 'Are you sure you want to delete this Address ?';
    const dialogData = new ConfirmDialogModel(messageReject, '');
    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
    dialogRef.afterClosed().subscribe((dialogResultReject) => {
      if (dialogResultReject) {
        const canAddrId = addrObj.fields.find((ele) => {
          return ele.name == 'candidateAddressID';
        }).value;
        console.log('in remove addr', addrObj, canAddrId);
        if (canAddrId != null) {
          this.apiData.deleteAddress([canAddrId]).subscribe((_res) => {
            this.genmodel.address.splice(index, 1);
            this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
          });
        } else {
          this.genmodel.address.splice(index, 1);
          this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
        }
      }
    });
  }

  addEduGaps() {
    this.genDefault = this.OriginalGenModel.gaps.filter((adFields) => {
      let count = 0;
      adFields.fields.forEach((field) => {
        if (field.value == null) {
          count++;
        }
      });
      if (count == adFields.fields.length && adFields.gapType == 'Gap in Education') {
        return adFields;
      }
    });
    const newEdugap = JSON.parse(JSON.stringify(this.genDefault[0]));
    this.genmodel.gaps.unshift(newEdugap);
  }

  addExpGaps() {
    this.genDefault = this.OriginalGenModel.gaps.filter((adFields) => {
      let count = 0;
      adFields.fields.forEach((field) => {
        if (field.value == null) {
          count++;
        }
      });
      if (count == adFields.fields.length && adFields.gapType == 'Gap in Experience') {
        return adFields;
      }
    });
    const newExpgap = JSON.parse(JSON.stringify(this.genDefault[0]));
    this.genmodel.gaps.unshift(newExpgap);
  }

  saveGaps() {
    const saveGap = this.getSaveGaps();
    if (saveGap != null) {
      this.wrapperObject = {
        "candidateEdGapDetail": {
          "candidateEmail": this.dynamicFormComponent.form.get('emailId').value,
          "candidateId": this.data.candidateId,
          "gaps": this.edugapsForm,
          "gapType": "ED"
        },
        "candidateExpGapDetail": {
          "candidateEmail": this.dynamicFormComponent.form.get('emailId').value,
          "candidateId": this.data.candidateId,
          "gaps": this.expgapsForm,
          "gapType": "EXP"
        },
        "action": "save"
      }
      this.apiData.editGapsInfo(this.wrapperObject).subscribe((res) => {
        console.log(res);
        this._personaService.openSnackBar(
          { msg: this.roleCheck ? this.ScsMsgHr : this.ScsMsg, isSuccess: true },
          'success-snack',
        );
        this.apiData.getdata(this.candprofile).subscribe((res) => {
          this.OriginalGenModel = JSON.parse(JSON.stringify(res));
          if (res.gaps) {
            const gapsRes = res.gaps.filter((adFields) => {
              let count = 0;
              adFields.fields.forEach((field) => {
                if (field.value == null) {
                  count++;
                }
              });
              if (count != adFields.fields.length) {
                return adFields;
              }
            });
            res.gaps = gapsRes;
          }
          if (this.genmodel) {
            this.genmodel.gaps = res.gaps;
          }
        });
      });
    }
  }

  removeGaps(index, _gapObj) {
    const messageReject = 'Are you sure you want to delete this Gap ?';
    const dialogData = new ConfirmDialogModel(messageReject, '');
    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
    dialogRef.afterClosed().subscribe((dialogResultReject) => {
      if (dialogResultReject) {
        console.log('in remove gap');
        this.genmodel.gaps.splice(index, 1);
        this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
      }
    });
  }

  addCompensation() {
    console.log('in add new compensation');
    // this.expBool = true;
    // let newExp = {...this.genmodel.experience[0]};
    // let newExp = JSON.parse(JSON.stringify(this.genmodel.compensation))
    // this.genDefault = this.OriginalGenModel.compensation.filter((adFields) => {
    //   let count = 0;
    //   adFields.fields.forEach((field) => {
    //     if (field.value == null) {
    //       count++;
    //     }
    //   })
    //   if (count == adFields.fields.length) {
    //     return adFields
    //   }
    // })

    for (let i = this.OriginalGenModel.compensation.length - 1; i > -1; i--) {
      const newComp = JSON.parse(JSON.stringify(this.OriginalGenModel.compensation[i]));
      newComp.fields.forEach((expField) => {
        expField.value = null;
        if (expField.options && expField.options.length > 0) {
          expField.options.forEach((expOptions) => {
            expOptions.selected = false;
          });
        }
      });
      console.log(newComp);

      this.genmodel.compensation.unshift(newComp);
    }
    // let newComp = JSON.parse(JSON.stringify(this.genmodel.compensation[0]))
    // newComp.fields.forEach((expField) => {
    //   expField.value = null;
    //   if (expField.options && expField.options.length > 0) {
    //     expField.options.forEach((expOptions) => {
    //       expOptions.selected = false;
    //     })
    //   }
    // })
  }

  saveCompensation() {
    const saveCompObj = this.getSaveCompensation();
    if (saveCompObj != null) {
      this.wrapperObject = {
        "candidateCnbDetail": saveCompObj,
        "action": "save"
      }
      this.apiData.editGapsInfo(this.wrapperObject).subscribe((res) => {
        console.log(res);
        this._personaService.openSnackBar(
          { msg: this.roleCheck ? this.ScsMsgHr : this.ScsMsg, isSuccess: true },
          'success-snack',
        );
        this.apiData.getdata(this.candprofile).subscribe((res) => {
          this.OriginalGenModel = JSON.parse(JSON.stringify(res));
          if (res.compensation) {
            const compRes = res.compensation.filter((adFields) => {
              let count = 0;
              adFields.fields.forEach((field) => {
                if (field.value == null) {
                  count++;
                }
              });
              if (count != adFields.fields.length) {
                return adFields;
              }
            });
            if (compRes.length == 0) {
              res.compensation = compRes;
            }
          }
          if (this.genmodel) {
            this.genmodel.compensation = res.compensation;
          }
        });
      });
    }
  }

  addAttachment() {
    console.log('in add new attachment', this.OriginalGenModel);
    // let newExp = {...this.genmodel.experience[0]};
    this.genDefault = this.OriginalGenModel.attachments.filter((adFields) => {
      let count = 0;
      adFields.fields.forEach((field) => {
        if (field.value == null) {
          count++;
        }
      });
      if (count == adFields.fields.length) {
        return adFields;
      }
    });
    console.log('in add new attachment', this.genDefault);
    const newAttach = JSON.parse(JSON.stringify(this.genDefault[0]));
    console.log(newAttach);
    // let newAddress = JSON.parse(JSON.stringify(this.genmodel.address[0]))
    this.genmodel.attachments.unshift(newAttach);
  }

  saveAttachment(funcCheck) {
    //  console.log(this.attachment)
    //  return
    if (this.companyHiringType == 9) {
      const checkDocId = this.attachment.some((atchForm) => {
        if (
          atchForm.form.get('attachmentType').value == 'Proof of Philhealth' ||
          atchForm.form.get('attachmentType').value == 'Proof of SSS' ||
          atchForm.form.get('attachmentType').value == 'Proof of PAGIBIG' ||
          atchForm.form.get('attachmentType').value == 'Proof of Tax Identification Number'
        ) {
          const id = atchForm.form.get('documentId').value;
          if (!id) {
            return true;
          } else {
            return false;
          }
        }
      });
      if (checkDocId) {
        this._personaService.openSnackBar({ msg: 'Please enter values', isSuccess: 'error' }, 'danger-snack');
        return;
      }
    }
    this.attachment.forEach((atchForm, index) => {
      console.log(atchForm.form.valid);
      console.log(
        atchForm.fileAttachArray,
        atchForm.fileAttachArray.length,
        atchForm.form.get('attachmentType').value,
        atchForm.form.get('attachmentBrowse').value,
      );
      if (
        atchForm.form.get('attachmentType').value != 'Proof of Philhealth' &&
        atchForm.form.get('attachmentType').value != 'Proof of SSS' &&
        atchForm.form.get('attachmentType').value != 'Proof of PAGIBIG' &&
        atchForm.form.get('attachmentType').value != 'Proof of Tax Identification Number' &&
        this.companyHiringType == 9
      ) {
        atchForm.form.get('documentId').setValidators([]);
        atchForm.form.get('documentId').updateValueAndValidity();
      }
      if (atchForm.form.valid) {
        console.log('atchForm.form.valid');
        if (index == 0) {
          this.ngxLoader.start();
        }
        if (index == this.attachment.length - 1 && atchForm.fileAttachArray.length < 1) {
          this.ngxLoader.stop();
          this._personaService.openSnackBar(
            { msg: this.roleCheck ? this.ScsMsgHr : this.ScsMsg, isSuccess: true },
            'success-snack',
          );
        }
        if (
          (atchForm.form.get('attachmentType').value == null && atchForm.form.get('attachmentBrowse').value == null) ||
          (atchForm.form.get('attachmentType').value != null && atchForm.form.get('attachmentBrowse').value == null) ||
          (atchForm.form.get('attachmentType').value == null && atchForm.form.get('attachmentBrowse').value != null)
        ) {
          this.genmodel.attachments.splice(index, 1);
        }

        // if ((atchForm.form.get('attachmentType').value == null && atchForm.form.get('attachmentBrowse').value == null) || (atchForm.form.get('attachmentType').value != null && atchForm.form.get('attachmentBrowse').value == null && atchForm.fileAttachArray.length < 1) || (atchForm.form.get('attachmentType').value == null && atchForm.form.get('attachmentBrowse').value == null && atchForm.fileAttachArray.length > 0)) {
        //   this.genmodel.attachments.splice(index, 1);
        // }

        if (atchForm.fileAttachArray.length > 0 && atchForm.form.get('attachmentType').value != null) {
          const fd = new FormData();
          fd.append('objectId', this.data.candidateId);
          fd.append('objectType', 'CD');
          fd.append('companyHiringTypeId', this.companyHiringType.toString());
          fd.append('attachmentId', atchForm.fileAttachArray[0].attachmentId);
          fd.append('file[' + atchForm.fileAttachArray[0].fileData.name + ']', atchForm.fileAttachArray[0].fileData);
          console.log(fd);
          this.saveAttachDisable = true;
          this.apiData.uploadImageData(fd).subscribe((data) => {
            console.log(data);
            if (data && data['ids'] && funcCheck == 'save') {
              if (atchForm.form.get('attachmentType').value.toLowerCase() == 'address_proof') {
                const addProofObj = {
                  candidateId: this.data.candidateId,
                  proofType: atchForm.form.get('addressProofType').value,
                };
                this.apiData.saveAddressProof(addProofObj).subscribe((res) => {
                  console.log(res);
                  this.saved = true;
                  this.apiData.setBool(this.saved);
                  console.log(this.saved, 'inside saved vF');
                });
              }
              if (
                atchForm.form.get('attachmentType').value == 'Proof of Philhealth' ||
                atchForm.form.get('attachmentType').value == 'Proof of SSS' ||
                atchForm.form.get('attachmentType').value == 'Proof of PAGIBIG' ||
                atchForm.form.get('attachmentType').value == 'Proof of Tax Identification Number'
              ) {
                console.log(atchForm.fileAttachArray[0].attachmentId);
                //  atchForm.form.get('documentId').setValidators([]);
                //  atchForm.form.get('documentId').updateValueAndValidity();
                const saveDocIdObj = {
                  applicationId: this.data.applicationId,
                  documentId: atchForm.form.get('documentId').value,
                  attachmentId: atchForm.fileAttachArray[0].attachmentId,
                };
                this.apiData.saveDocumentId(saveDocIdObj).subscribe((res) => {
                  console.log(res);
                  this.saveDocId = true;
                  this.apiData.setBool(this.saveDocId);
                  console.log(this.saveDocId, 'Inside save func');
                });
              }

              if (atchForm.form.get('attachmentType').value.toLowerCase() == 'resume') {
                const resumeParser = {
                  candidateId: this.data.candidateId,
                  applicationId: this.data.applicationId,
                  fileId: Object.keys(data['ids'])[0],
                };
                this.apiData.ParserAIUpload(resumeParser).subscribe(
                  (resume) => {
                    console.log('resume uploaded to ParserAI', resume);
                    // this._personaService.openSnackBar({ msg: "Resume uploaded to Parser AI", isSuccess: true }, 'success-snack');
                  },
                  (_err) => {
                    this._personaService.openSnackBar(
                      { msg: 'Failed to upload resume to parser AI', isSuccess: 'error' },
                      'danger-snack',
                    );
                  },
                );
              }
              if (index == this.attachment.length - 1) {
                this.ngxLoader.stop();
                this._personaService.openSnackBar(
                  { msg: this.roleCheck ? this.ScsMsgHr : this.ScsMsg, isSuccess: true },
                  'success-snack',
                );
              }
              this.apiData.getdata(this.candprofile).subscribe((resVp_) => {
                this.saveAttachDisable = false;
                this.OriginalGenModel = JSON.parse(JSON.stringify(resVp_));
                if (resVp_.attachments) {
                  const attchRes = resVp_.attachments.filter((adFields) => {
                    let count = 0;
                    adFields.fields.forEach((field) => {
                      if (field.value == null) {
                        count++;
                      }
                    });
                    if (count != adFields.fields.length) {
                      return adFields;
                    }
                  });
                  resVp_.attachments = attchRes;
                }
                this.attachmentsList = JSON.parse(JSON.stringify(resVp_.attachments));

                if (this.companyHiringType == 4 || this.companyHiringType == 5) {
                  const xAttachSa_ = resVp_.attachments.filter((eleSa_) => {
                    const attachIdSa_ = eleSa_.fields.find((field) => field.name === 'attachmentType').options[0].key;
                    if (!(
                      this.XAttachmentIds.indexOf(attachIdSa_) != -1 ||
                      this.XIIMarksAttachIds.indexOf(attachIdSa_) != -1 ||
                      this.gradSemAttachIds.indexOf(attachIdSa_) != -1 ||
                      this.gradConsAttachIds.indexOf(attachIdSa_) != -1 ||
                      this.postgradSemAttachIds.indexOf(attachIdSa_) != -1 ||
                      this.postgradConsAttachIds.indexOf(attachIdSa_) != -1 ||
                      this.diplomaSemAttachIds.indexOf(attachIdSa_) != -1 ||
                      this.diplomaConsAttachIds.indexOf(attachIdSa_) != -1
                    )) {
                      return eleSa_;
                    }
                  });
                  resVp_.attachments = xAttachSa_;
                }
                if (this.genmodel) {
                  this.genmodel.attachments = resVp_.attachments;
                }
              });
            }
          },(_err)=>{
          this.saveAttachDisable = false;
          console.log(_err);
          this.ngxLoader.stop();
          this._personaService.openSnackBar({ msg: "Failed to upload attachment", isSuccess: 'error' }, 'danger-snack');
         });
        }
      } else {
        console.log('atchForm.form.valid');
        atchForm.form.markAllAsTouched();
        this._personaService.openSnackBar({ msg: 'Please enter values', isSuccess: 'error' }, 'danger-snack');
        return;
      }
    });
  }
  // countrycodevalue(val: any) {
  //   this.countrycode = val;
  //   console.log('val--', this.countrycode);
  // }
  // countrycodevalue2(val: any) {
  //   this.countrycode2 = val;
  //   console.log('val--', this.countrycode2);
  // }
  // countrycodevalue3(val: any) {
  //   this.countrycode3 = val;
  //   console.log('val--', this.countrycode3);
  // }
  removeAttachment(index, value) {
    const messageReject = 'Are you sure you want to delete this Attachment ?';
    const dialogData = new ConfirmDialogModel(messageReject, '');
    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
    dialogRef.afterClosed().subscribe((dialogResultReject) => {
      if (dialogResultReject) {
        console.log(value);
        if (value.fields.find((x) => x.name == 'attachmentBrowse').url) {
          this.http.get<any>(value.fields.find((x) => x.name == 'attachmentBrowse').url).subscribe((fileres) => {
            const fileId = fileres.fileId;
            this.apiData.deleteFile(fileId).subscribe(
              (resRa_) => {
                console.log(resRa_);
                this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
                this.apiData.getdata(this.candprofile).subscribe((resRaIn_) => {
                  this.OriginalGenModel = JSON.parse(JSON.stringify(resRaIn_));
                  if (resRaIn_.attachments) {
                    const attchResRaIn_ = resRaIn_.attachments.filter((adFieldsRaIn_) => {
                      let count = 0;
                      adFieldsRaIn_.fields.forEach((fieldRaIn_) => {
                        if (fieldRaIn_.value == null) {
                          count++;
                        }
                      });
                      if (count != adFieldsRaIn_.fields.length) {
                        return adFieldsRaIn_;
                      }
                    });
                    resRaIn_.attachments = attchResRaIn_;

                    this.attachmentsList = JSON.parse(JSON.stringify(resRaIn_.attachments));

                    if (this.companyHiringType == 4 || this.companyHiringType == 5) {
                      const xAttachSa_ = resRaIn_.attachments.filter((eleSa_) => {
                        const attachIdSa_ = eleSa_.fields.find((field) => field.name === 'attachmentType').options[0]
                          .key;
                        if (!(
                          this.XAttachmentIds.indexOf(attachIdSa_) != -1 ||
                          this.XIIMarksAttachIds.indexOf(attachIdSa_) != -1 ||
                          this.gradSemAttachIds.indexOf(attachIdSa_) != -1 ||
                          this.gradConsAttachIds.indexOf(attachIdSa_) != -1 ||
                          this.postgradSemAttachIds.indexOf(attachIdSa_) != -1 ||
                          this.postgradConsAttachIds.indexOf(attachIdSa_) != -1 ||
                          this.diplomaSemAttachIds.indexOf(attachIdSa_) != -1 ||
                          this.diplomaConsAttachIds.indexOf(attachIdSa_) != -1
                        )) {
                          return eleSa_;
                        }
                      });
                      resRaIn_.attachments = xAttachSa_;
                    }
                  }
                  if (this.genmodel) {
                    this.genmodel.attachments = resRaIn_.attachments;
                  }
                });
              },
              (_err) => {},
            );
          });
        } else {
          this.genmodel.attachments.splice(index, 1);
          this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
        }
      }
    });
  }

  submitDisable() {
    this.educationFormInvalid = false;
    this.expFormInvalid = false;
    this.addressFormInvalid = false;
    let gapsInvalid = false;
    let compInvalid = false;
    this.education.forEach((edu: DynamicCandidateProfileComponent, _index) => {
      if (!edu.form.valid) {
        this.educationFormInvalid = true;
      }
    });
    this.canAddress.forEach((adr: DynamicCandidateProfileComponent, _index) => {
      if (!adr.form.valid) {
        this.addressFormInvalid = true;
      }
    });
    this.workexperience.forEach((exp: DynamicCandidateProfileComponent, _index) => {
      if (!exp.form.valid) {
        this.expFormInvalid = true;
      }
    });
    this.eduExpgaps.forEach((exp: DynamicCandidateProfileComponent, _index) => {
      // console.log("edu form",exp.form.controls['country_code'].setValue(this.countrycode));
      // console.log("edu form",exp.form.controls['country_code2'].setValue(this.countrycode2));
      // console.log("edu form",exp.form.controls['country_code3'].setValue(this.countrycode3));

      if (!exp.form.valid) {
        gapsInvalid = true;
      }
    });
    this.compensation.forEach((exp: DynamicCandidateProfileComponent, _index) => {
      // console.log("edu form",exp.form.controls['country_code'].setValue(this.countrycode));
      // console.log("edu form",exp.form.controls['country_code2'].setValue(this.countrycode2));
      // console.log("edu form",exp.form.controls['country_code3'].setValue(this.countrycode3));
      if (!exp.form.valid) {
        compInvalid = true;
      }
    });
    // console.log("submit---",this.educationFormInvalid,this.expFormInvalid,gapsInvalid,compInvalid,this.dynamicFormComponent.form.invalid)
    if (
      this.educationFormInvalid ||
      this.dynamicFormComponent.form.invalid ||
      this.expFormInvalid ||
      this.addressFormInvalid ||
      gapsInvalid ||
      compInvalid
    ) {
      return true;
    } else {
      return false;
    }
  }

  getSaveBasic() {
    const form = this.dynamicFormComponent.form;

    if (!this.infyProfileEdit) {
      const lastNameCtrl = form.get('lastName');
      if (lastNameCtrl?.value) {
        lastNameCtrl.setValue(lastNameCtrl.value.trim());
      }

      const middleNameCtrl = form.get('middleName');
      middleNameCtrl.setValidators([]);
      middleNameCtrl.updateValueAndValidity();

      if (!form.valid) {
        form.markAllAsTouched();
        this._personaService.openSnackBar({ msg: 'Please enter values', isSuccess: 'error' }, 'danger-snack');
        return null;
      }
    }

  let basicForm = this.infyProfileEdit ? form.getRawValue() : form.value;
  basicForm.dateOfBirth = basicForm.dateOfBirth
    ? this.datePipe.transform(new Date(basicForm.dateOfBirth), "yyyy-MM-dd")
    : null;
  basicForm.candidateId = this.data.candidateId;
  basicForm.applicationId = this.data.applicationId;
  basicForm.exEmployeeNo = basicForm.employeeNo;
  const formatPhone = (num, code) => (num && code) ? `+${code}-${num}` : num || null;
  basicForm.primaryContactNo = formatPhone(basicForm.primaryContactNo, basicForm.country_code);
  basicForm.alternateContactNo = formatPhone(basicForm.alternateContactNo, basicForm.country_code2);
  basicForm.emergencyContactNo = formatPhone(basicForm.emergencyContactNo, basicForm.country_code3);

  const genderField = this.genmodel.fields.find(res => res.name === "gender");
  if (basicForm.gender && genderField) {
    const validOptions = (genderField.options ?? []).filter(opt => opt.value != null);
    const selected = validOptions.find(opt => opt.value.toLowerCase() === basicForm.gender.toLowerCase());
    basicForm.gender = selected?.key?.toString() || null;
  }

  basicForm.newSkillId = (basicForm.digitalTag || []).map(tag => tag?.key).filter(k => k != null);

    delete basicForm.employeeNo;
    delete basicForm.skill;
    delete basicForm.digitalTag;
    delete basicForm.panNumber;

    this.basicInfoForm = basicForm;
    return basicForm;
  }

  getSaveEducation() {
    this.educationForm = [];
    let univError = false;
    if (this.genmodel.educations) {
      this.genmodel.educations.forEach((education) => {
        this.degreeNameList.push(education.degreeName);
      });
      console.log(this.genmodel);
      this.education.forEach((edu: DynamicCandidateProfileComponent, _index) => {
        console.log(edu);
        if (edu.form.get('institute').value) {
          edu.form.get('institute').setValue(edu.form.value.institute.trim());
        }
        if (edu.form.valid) {
          // this.educationFormInvalid = false;
          console.log(edu.form.value); // append here
          const educationForm = JSON.parse(JSON.stringify(edu.form.value));
          // populating req body
          educationForm.degreeName = educationForm.degree;
          educationForm.candidateId = this.data.candidateId;
          educationForm.yearOfPassing = educationForm.yearOfPassing
            ? this.adjustForTimezone(new Date(educationForm.yearOfPassing))
            : null;
          educationForm.yearOfJoining = educationForm.yearOfJoining
            ? this.adjustForTimezone(new Date(educationForm.yearOfJoining))
            : null;
          // educationForm.domainvaluesid = "";
          // educationForm.educationTypeName = educationForm.education_type;
          const uni = this.genmodel.educations[0].fields.find((res) => res.name === 'universityName');
          if (edu.form.value.universityName) {
            let tempOptions = (uni?.options ?? []).filter(temp => temp.value != null)
            let uniId = tempOptions.find(res => res.value.toLowerCase() === edu.form.value.universityName.toLowerCase());
            let universityId = uniId ? uniId.key : null;
            if (universityId) {
              educationForm.universityCode = universityId;
            } else {
              // educationForm.universityName = edu.form.value.universityName;
              // edu.form.get('universityName').setValue(null);
              educationForm.universityCode = null;
            }
          } else {
            educationForm.universityCode = null;
          }
          const _inst = this.genmodel.educations[0].fields.find((res) => res.name === 'institute');
          if (edu.form.value.institute) {
            console.log(this.genmodel.educations);
            // let tempOptions = inst.options.filter(temp => temp.value != null)
            // let uniId = tempOptions.find(res => res.value.toLowerCase() === edu.form.value.institute.toLowerCase());
            // let universityId = uniId ? uniId.key : null;
            console.log(
              edu.form.get('institute').value,
              edu.form.value.institute,
              edu.form.get('institute')['instituteId'],
            );

            const universityId = edu.form.get('institute')['instituteId']
              ? edu.form.get('institute')['instituteId']
              : null;
            if (universityId) {
              educationForm.instituteId = universityId;
              educationForm.instituteName = null;
            } else {
              if (
                edu.form.value.candidateEducationType == 'XII/SSC/High/Equivalent' ||
                edu.form.value.candidateEducationType == 'X/SSLC/Junior/Equivalent' ||
                edu.form.value.candidateEducationType == 'Graduation/Bachelor/Equivalent' ||
                edu.form.value.candidateEducationType == 'Post Grad/Master/Equivalent' ||
                edu.form.value.candidateEducationType == 'Diploma'
              ) {
                educationForm.instituteName = edu.form.value.institute;
                educationForm.instituteId = null;
              } else {
                for (let i = 0; i < this.OriginalGenModel.educations.length; i++) {
                  const instituteObj = this.OriginalGenModel.educations[i].fields.find(
                    (res) => res.name === 'institute',
                  );
                  const candEduTypeObj = this.OriginalGenModel.educations[i].fields.find(
                    (res) => res.name === 'candidateEducationType',
                  );
                  if (
                    instituteObj.value &&
                    instituteObj.value.toLowerCase().trim() == edu.form.get('institute').value.toLowerCase().trim() &&
                    candEduTypeObj.value.toLowerCase().trim() ==
                      edu.form.get('candidateEducationType').value.toLowerCase().trim()
                  ) {
                    educationForm.instituteName = edu.form.get('institute').value;
                    educationForm.instituteId = null;
                    break;
                  } else {
                    educationForm.instituteName = null;
                    educationForm.instituteId = null;
                  }
                }

                // // edu.form.get('institute').setValue(null);
                // educationForm.instituteName = null;
                // educationForm.instituteId = null;
              }
            }
            // delete educationForm.institute;
          } else {
            educationForm.instituteName = null;
            educationForm.instituteId = null;
          }
          const canEduType = this.genmodel.educations[0].fields.find((res) => res.name === 'candidateEducationType');
          if (edu.form.value.candidateEducationType) {
            let tempOptions = (canEduType?.options ?? []).filter(temp => temp.value != null)
            let uniId = tempOptions.find(res => res.value.toLowerCase() === edu.form.value.candidateEducationType.toLowerCase());
            let universityId = uniId ? uniId.key : null;
            educationForm.candidateEducationTypeId = universityId;
            educationForm.candidateEducationType = edu.form.value.candidateEducationType;
          }
          const splName = this.genmodel.educations[0].fields.find((res) => res.name === 'specializationName');
          if (edu.form.value.specializationName) {
            let tempOptions = (splName?.options ?? []).filter(temp => temp.value != null)
            let splId = tempOptions.find(res => res.value.toLowerCase() === edu.form.value.specializationName.toLowerCase());
            let specialId = splId ? splId.key : null;
            educationForm.specializationId = specialId;
          } else {
            educationForm.specializationId = null;
          }
          const degreeOptions = this.genmodel.educations[0].fields.find((res) => res.name === 'degree');
          if (edu.form.value.degree) {
            let tempOptions = (degreeOptions?.options ?? []).filter(temp => temp.value != null)
            let uniId = tempOptions.find(res => (res.key === edu.form.value.degree || res.value === edu.form.value.degree));
            let degreeId = uniId ? uniId.key : null;
            if (degreeId) {
              educationForm.degree = degreeId;
            } else {
              // edu.form.get('degree').setValue(null);
              educationForm.degree = null;
            }
          } else {
            educationForm.degree = null;
          }
          const edutype = this.genmodel.educations[0].fields.find((res) => res.name === 'education_type');
          if (edu.form.value.education_type) {
            let tempOptions = (edutype?.options ?? []).filter(temp => temp.value != null)
            let edutypeId = tempOptions.find(res => res.value.toLowerCase() === edu.form.value.education_type.toLowerCase());
            let educationtypeId = edutypeId ? edutypeId.key : null;
            if (educationtypeId) {
              educationForm.domainValuesId = educationtypeId;
            } else {
              educationForm.education_type = edu.form.value.education_type;
            }
          } else {
            educationForm.domainValuesId = null;
          }
          if (
            edu.form.value.highestDegree &&
            (edu.form.value.highestDegree == true || edu.form.value.highestDegree == 'Y')
          ) {
            educationForm.highestDegree = 'Y';
          } else {
            educationForm.highestDegree = 'N';
          }
          if (
            (educationForm.degree == null && edu.form.value.degree) ||
            (educationForm.universityCode == null && edu.form.value.universityName) ||
            (educationForm.instituteName == null && educationForm.instituteId == null && edu.form.value.institute) ||
            (edu.form.value.specializationName && educationForm.specializationId == null)
          ) {
            univError = true;
            this.educationForm.push(null);
          } else {
            console.log(educationForm);
            let temp = {
              "candidateId": this.data.candidateId,
              "educationId": educationForm.candidateEducationId? educationForm.candidateEducationId.trim():null,
              "startDate": educationForm.yearOfJoining ? this.datePipe.transform(new Date(educationForm.yearOfJoining), 'yyyy-MM-ddTHH:mm:ss.SSSZ') : null,
              "endDate": educationForm.yearOfPassing ? this.datePipe.transform(new Date(educationForm.yearOfPassing), 'yyyy-MM-ddTHH:mm:ss.SSSZ') : null,
              "institute": educationForm.instituteName? educationForm.instituteName.trim(): null,
              "universityCode": educationForm.universityCode? String(educationForm.universityCode):null,
              "specializationId": educationForm.specializationId ? String(educationForm.specializationId) : null,
              "highestDegree": educationForm.highestDegree || null,
              "grade": educationForm.percentage? String(educationForm.percentage):null,
              "domainValueId": educationForm.domainValuesId,
              "degreeId": educationForm.degree,
              "educationTypeId": educationForm.candidateEducationTypeId,
              "countryCode": null,
              "stateCode": null,
              "cityId": null,
              "instituteId": educationForm.instituteId ? parseInt(educationForm.instituteId) : 0,
              "universityName": educationForm.universityName? educationForm.universityName.trim():null,
              "specializationName": educationForm.specializationName? educationForm.specializationName.trim(): null,
              "degreeName": educationForm.degreeName? educationForm.degreeName.trim(): null,
              "educationTypeName": educationForm.candidateEducationType? educationForm.candidateEducationType.trim(): null,
              "state": null
            }
            this.educationForm.push(temp);

            // this.educationForm.push(educationForm);
            console.log(this.educationForm);
          }
        } else {
          // if education form not valid
          // this.educationFormInvalid = true;
          edu.form.markAllAsTouched();
          this.educationForm.push(null);
        }
      });
    }
    const tempSaveCheck = this.educationForm.filter((res) => {
      return res != null;
    });
    if (tempSaveCheck.length == this.educationForm.length) {
      this.eduBool = false;
      let countHighDegree = 0;
      this.educationForm.forEach((edu) => {
        if (edu['highestDegree'] == 'Y') {
          countHighDegree++;
        }
      });

      for (const edu of this.educationForm) {
        if (edu['startDate'] != null && edu['endDate'] != null) {
          if (moment(edu['startDate']).isSameOrAfter(moment(edu['endDate']), 'day')) {
            this._personaService.openSnackBar(
              {
                msg: `Year of Joining should be less than Year of Passing for ${edu['educationTypeName']}`,
                isSuccess: 'error',
              },
              'danger-snack',
            );
            return null;
          }
        }
      }
      if (countHighDegree > 1) {
        this._personaService.openSnackBar(
          { msg: 'Only one Highest Degree Allowed', isSuccess: 'error' },
          'danger-snack',
        );
        return null;
      } else {
        const { isDuplicate, education1Name, education2Name } = this.educationDupDegreeCheck(this.educationForm);
        if (isDuplicate && this.companyHiringType == 1) {
          this._personaService.openSnackBar(
            { msg: `Degree cannot be same for ${education1Name} and ${education2Name}`, isSuccess: 'error' },
            'danger-snack',
          );
          return null;
        }
        if (this.educationDupCheck(this.educationForm)) {
          this._personaService.openSnackBar(
            { msg: 'Degree and Specialization cannot be same for two educations', isSuccess: 'error' },
            'danger-snack',
          );
          return null;
        } else {
          return this.educationForm;
        }
      }
    } else {
      if (univError) {
        this._personaService.openSnackBar(
          {
            msg: 'Please select values from dropdown for University, Institute, Degree, Specialization',
            isSuccess: 'error',
          },
          'danger-snack',
        );
      } else {
        this._personaService.openSnackBar(
          { msg: 'Please fill the required fields', isSuccess: 'error' },
          'danger-snack',
        );
      }

      return null;
    }
    // return this.educationForm;
  }

  getSaveExperience() {
    // Work Experience
    // console.log(this.workexperience.value);
    this.experienceForm = [];
    if (this.genmodel.experience) {
      this.workexperience.forEach((exp: DynamicCandidateProfileComponent, _index) => {
        if (exp.form.get('currentEmployer').value) {
          exp.form.get('currentEmployer').setValue(exp.form.value.currentEmployer.trim());
        }
        if (exp.form.get('designation').value) {
          exp.form.get('designation').setValue(exp.form.value.designation.trim());
        }
        if (!exp.form.value.tillDate) {
          exp.form.get('noticePeriod')?.clearValidators();
          exp.form.get('noticePeriod')?.updateValueAndValidity();
        } else {
          exp.form.get('noticePeriod')?.setValidators([Validators.required]);
          exp.form.get('noticePeriod')?.updateValueAndValidity();
        }

        if (exp.form.valid) {
          this.expFormInvalid = false;
          const experienceForm = exp.form.value;
          const org = this.genmodel.experience[0].fields.find((res) => res.name === 'currentEmployer');
          if (exp.form.value.currentEmployer) {
            const tempOptions = org.options.filter((temp) => temp.value != null);
            const orgId = tempOptions.find(
              (res) => res.value.toLowerCase() === exp.form.value.currentEmployer.toLowerCase(),
            );
            const organizationId = orgId ? orgId.key : null;
            if (organizationId) {
              experienceForm.organizationId = organizationId;
            } else {
              experienceForm.organizationName = exp.form.value.currentEmployer;
            }
          }
          if (exp.form.value.tillDate && (exp.form.value.tillDate == true || exp.form.value.tillDate == 'Y')) {
            experienceForm.tillDate = 'Y';
          } else {
            experienceForm.tillDate = 'N';
          }
          if (
            exp.form.value.bgVerification &&
            (exp.form.value.bgVerification == true ||
              exp.form.value.bgVerification == 'Y' ||
              exp.form.value.bgVerification == 'Yes')
          ) {
            experienceForm.bgVerification = 'Y';
          } else {
            experienceForm.bgVerification = 'N';
          }
          if (experienceForm.dateOfLeaving != null) {
            experienceForm.dateOfLeaving = this.adjustForTimezone(new Date(experienceForm.dateOfLeaving));
          }
          if (experienceForm.dateOfJoining != null) {
            experienceForm.dateOfJoining = this.adjustForTimezone(new Date(experienceForm.dateOfJoining));
          }

          experienceForm.candidateId = this.data.candidateId;
          experienceForm.applicationId = this.data.applicationId;
          // experienceForm.createdBy = this.loginEmpNo;
          // experienceForm.createdOn = new Date();
          // experienceForm.modifiedBy = this.loginEmpNo;
          // experienceForm.modifiedOn = new Date();
          let tempExperience = {
            "candidateId": this.data.candidateId,
            'experienceId': experienceForm.candidateExperienceId? experienceForm.candidateExperienceId.trim(): null,
            'organizationId': experienceForm.organizationId?experienceForm.organizationId:null,
            'organizationName':experienceForm.organizationName?experienceForm.organizationName.trim():null,
            'designation': experienceForm.designation.trim(),
            'joinedDate': experienceForm.dateOfJoining,
            'leftDate': experienceForm.dateOfLeaving,
            'noticePeriod': experienceForm.noticePeriod? parseInt(experienceForm.noticePeriod):null,
            'currentEmployer': experienceForm.tillDate,
            'bgVerification': experienceForm.bgVerification,
          }
          this.experienceForm.push(tempExperience);
        } else {
          this.expFormInvalid = true;
          this.experienceForm.push(null);
          exp.form.markAllAsTouched();
        }
      });
    }
    const tempSaveCheck = this.experienceForm.filter((res) => {
      return res != null;
    });
    if (tempSaveCheck.length == this.experienceForm.length) {
      let countExpTill = 0;
      this.experienceForm.forEach((exp) => {
        if (exp['currentEmployer'] == 'Y') {
          countExpTill++;
        }
      });

      for (const exp of this.experienceForm) {
        if (exp['joinedDate'] != null && exp['leftDate'] != null && this.companyHiringType == 1) {
          if (moment(exp['joinedDate']).isSameOrAfter(moment(exp['leftDate']), 'day')) {
            let organizationName = '';
            if (exp['organizationId']) {
              const organization = this.genmodel.experience[0].fields.find((res) => res.name === 'currentEmployer');
              organizationName = organization.options.find((opt) => opt.key === exp['organizationId'])?.value;
            }
            const companyName = exp['organizationName'] ? exp['organizationName'] : organizationName;
            this._personaService.openSnackBar(
              {
                msg: `Date of Joining cannot be same as or after Date of Leaving for ${companyName} `,
                isSuccess: 'error',
              },
              'danger-snack',
            );
            return null;
          }
        }
      }

      if (countExpTill > 1) {
        this._personaService.openSnackBar(
          { msg: 'Only one Current Employer Allowed', isSuccess: 'error' },
          'danger-snack',
        );
        return null;
      } else {
        this.expBool = false;
        console.log(this.experienceForm);
        return this.experienceForm;
      }
    } else {
      this._personaService.openSnackBar({ msg: 'Please enter values', isSuccess: 'error' }, 'danger-snack');
      return null;
    }
    // return this.experienceForm
  }

  adjustForTimezone(date: Date): Date {
    const timeOffsetInMS: number = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() - timeOffsetInMS);
    return date;
  }
  getSaveAddress() {
    this.addressForm = [];
    if (this.genmodel.address) {
      this.canAddress.forEach((addr: DynamicCandidateProfileComponent, _index) => {
        if (addr.form.get('houseNo').value) {
          addr.form.get('houseNo').setValue(addr.form.value.houseNo.trim());
        }
        if (addr.form.get('area').value) {
          addr.form.get('area').setValue(addr.form.value.area.trim());
        }
        if (addr.form.valid) {
          this.expFormInvalid = false;
          const addrForm = JSON.parse(JSON.stringify(addr.form.value));
          addrForm.candidateId = this.data.candidateId;
          addrForm.address1 = addr.form.value.houseNo;
          addrForm.address2 = addr.form.value.area;
          addrForm.postcode = addr.form.value.pinCode;
          addrForm.candAddressId = addr.form.value.candidateAddressID;
          delete addrForm.houseNo;
          delete addrForm.pinCode;
          delete addrForm.area;
          delete addrForm.city;
          const addrOptions = this.genmodel.address[0].fields.find((res) => res.name === 'addressType');
          if (addr.form.get('addressType').value) {
            addrForm.addressType = addr.form.get('addressType').value;
            const tempOptions = addrOptions.options.filter((temp) => temp.value != null);
            const adrId = tempOptions.find(
              (res) => res.value.toLowerCase() === addr.form.get('addressType').value.toLowerCase(),
            );
            const addressTypeId = adrId ? adrId.key : null;
            if (addressTypeId) {
              addrForm.addressTypeId = addressTypeId;
            } else {
              addrForm.organizationName = addr.form.value.addressType;
            }
          }
          console.log(addr.form.get('city').value, addr.form.value.city, '123456');

          if (addr.form.get('city').value && addr.form.get('state').value && addr.form.get('country').value) {
            // let cityurl = this.genmodel.address[0].fields.find(res => res.name === "city");
            // this.http.get<any[]>(cityurl.url + addr.form.get('city').value).subscribe((res) => {
            //   let temp = [];
            //   res.forEach((res, key) => {
            //     temp.push({ key: res['city_id'], value: res['city_state_country'] });
            //   })
            //   let cityId = null;
            //   if (addr.form.get('city').value.includes(',')) {
            //     cityId = temp.find(cityData => cityData.value === addr.form.get('city').value);
            //   }
            //   else {
            //     cityId = temp.find(cityData => cityData.value.toLowerCase().includes(addr.form.get('city').value.toLowerCase()));
            //   }
            //   let cityStateid = cityId ? cityId.key : null;
            //   addrForm.cityId = cityStateid;
            //   this.addressForm.push(addrForm);
            // });
            console.log(addr.form.get('city')['cityId'], '--------------');
            addrForm.cityId = addr.form.get('city')['cityId'];
          } else {
            addr.form.get('city').setValue(null);
            addrForm.cityId = null;
          }
          let tempAddress ={
            "candidateId": this.data.candidateId,
            'addressId': addrForm.candAddressId? addrForm.candAddressId.trim(): null,
            'addressTypeId': addrForm.addressTypeId,
            'address1' : addrForm.address1.trim(),
            'address2' : addrForm.address2.trim(),
            'cityId':  addrForm.cityId,
            'postcode' : addrForm.postcode
          }
          addrForm.cityId == null ? this.addressForm.push(null) : this.addressForm.push(tempAddress);
        }
        else {
          this.addressForm.push(null);
          addr.form.markAllAsTouched();
          this.addressFormInvalid = true;
        }
      });
    }
    const tempSaveCheck = this.addressForm.filter((res) => {
      return res != null;
    });
    if (tempSaveCheck.length == this.addressForm.length) {
      if (this.addressForm.length > 1 && this.addressForm[0]['addressTypeId'] == this.addressForm[1]['addressTypeId']) {
        this._personaService.openSnackBar(
          { msg: 'Only one Permanent & Only one Present Address Allowed', isSuccess: 'error' },
          'danger-snack',
        );
        return null;
      }
      console.log(this.addressForm);
      return this.addressForm;
    } else {
      this._personaService.openSnackBar({ msg: 'Please enter values', isSuccess: 'error' }, 'danger-snack');
      return null;
    }
    // return this.addressForm
  }

  getSaveGaps() {
    this.edugapsForm = [];
    this.expgapsForm = [];
    if (this.genmodel.gaps) {
      this.genmodel.gaps.forEach((genGap, index) => {
        if (genGap.gapType == 'Gap in Education') {
          if (this.eduExpgaps['_results'][index].form.get('reason').value) {
            this.eduExpgaps['_results'][index].form
              .get('reason')
              .setValue(this.eduExpgaps['_results'][index].form.get('reason').value.trim());
          }
          const eduForm: DynamicCandidateProfileComponent = this.eduExpgaps['_results'][index];
          if (eduForm.form.valid) {
            const edugapForm = eduForm.form.value;
            edugapForm.toDate = this.datePipe.transform(new Date(eduForm.form.value.to_date), 'yyyy-MM-dd');
            edugapForm.fromDate = this.datePipe.transform(new Date(eduForm.form.value.from_date), 'yyyy-MM-dd');
            edugapForm.reason = edugapForm.reason ? edugapForm.reason.trim() : null;
            delete edugapForm.to_date;
            delete edugapForm.from_date;
            this.edugapsForm.push(edugapForm);
          } else {
            eduForm.form.markAllAsTouched();
            this.edugapsForm.push(null);
          }
        }
        if (genGap.gapType == 'Gap in Experience') {
          if (this.eduExpgaps['_results'][index].form.get('reason').value) {
            this.eduExpgaps['_results'][index].form
              .get('reason')
              .setValue(this.eduExpgaps['_results'][index].form.get('reason').value.trim());
          }
          const eduForm: DynamicCandidateProfileComponent = this.eduExpgaps['_results'][index];
          if (eduForm.form.valid) {
            const edugapForm = eduForm.form.value;
            edugapForm.toDate = this.datePipe.transform(new Date(eduForm.form.value.to_date), 'yyyy-MM-dd');
            edugapForm.fromDate = this.datePipe.transform(new Date(eduForm.form.value.from_date), 'yyyy-MM-dd');
            edugapForm.reason = edugapForm.reason ? edugapForm.reason.trim() : null;
            delete edugapForm.to_date;
            delete edugapForm.from_date;
            this.expgapsForm.push(edugapForm);
          } else {
            eduForm.form.markAllAsTouched();
            this.expgapsForm.push(null);
          }
        }
      });
    }
    const tempSaveCheck = this.edugapsForm.filter((res) => {
      return res != null;
    });
    const tempSaveCheck1 = this.expgapsForm.filter((res) => {
      return res != null;
    });
    if (tempSaveCheck.length != this.edugapsForm.length || tempSaveCheck1.length != this.expgapsForm.length) {
      this._personaService.openSnackBar({ msg: 'Please enter values', isSuccess: 'error' }, 'danger-snack');
      return null;
    } else {
      return [];
    }
  }

  getSaveCompensation() {
    this.compensationForm = [];
    this.compensationLabels = [];
    if (this.genmodel.compensation) {
      this.genmodel.compensation.forEach((comps) => {
        this.compensationLabels.push(comps.label);
      });
      this.compensation.forEach((comp: DynamicCandidateProfileComponent, index) => {
        if (comp.form.valid) {
          const compForm = JSON.parse(JSON.stringify(comp.form.value));
          if (this.compensationLabels[index] == 'Current Compensation and Benefits') {
            compForm.candidateId = this.data.candidateId;
            compForm.cnbTypeName = "CURRENT_CNB";
            compForm.annualCompensation = comp.form.value.currentAnnualGrossCompensation
            compForm.fixedSalary = comp.form.value.fixedSalary
            compForm.variablePay = comp.form.value.variablePay
            compForm.otherBenefits = comp.form.value.otherBenefits? comp.form.value.otherBenefits.trim() : null,
            compForm.nextRevisionDate = null;
            delete compForm.currentAnnualGrossCompensation;
          }
          if (this.compensationLabels[index] == 'Next Revision Expected') {
            compForm.candidateId = this.data.candidateId;
            compForm.cnbTypeName = "NEXT_REVISION";
            compForm.annualCompensation = comp.form.value.revisedAnnualGrossCompensation
            compForm.fixedSalary = null;
            compForm.variablePay = null;
            compForm.otherBenefits = '';
            compForm.nextRevisionDate = comp.form.value.monthAndYear
              ? this.adjustForTimezone(new Date(comp.form.value.monthAndYear))
              : null;
            delete compForm.monthAndYear;
            delete compForm.revisedAnnualGrossCompensation;
          }
          if (this.compensationLabels[index] == 'Expectation at Infosys') {
            compForm.candidateId = this.data.candidateId;
            compForm.cnbTypeName = "EXPECTATION";
            compForm.annualCompensation = comp.form.value.expectedAnnualGrossCompensation
            compForm.fixedSalary = null;
            compForm.variablePay = null;
            compForm.otherBenefits = '';
            compForm.nextRevisionDate = null;
            delete compForm.expectedAnnualGrossCompensation;
          }
          this.compensationForm.push(compForm);
        } else {
          comp.form.markAllAsTouched();
          this.compensationForm.push(null);
        }
      });
    }
    const tempSaveCheck = this.compensationForm.filter((res) => {
      return res != null;
    });
    if (tempSaveCheck.length == this.compensationForm.length) {
      return this.compensationForm;
    } else {
      this._personaService.openSnackBar({ msg: 'Please enter values', isSuccess: 'error' }, 'danger-snack');
      return null;
    }
  }

  saveDisable(FieldName) {
    let tempBool = false;
    if (FieldName == 'educations') {
      this.eduExpgaps.forEach((_edu: DynamicCandidateProfileComponent, _index) => {
        // edu.form.controls['country_code'].setValue(this.countrycode);
        // edu.form.controls['country_code2'].setValue(this.countrycode2);
        // edu.form.controls['country_code3'].setValue(this.countrycode3);
      });
      this.compensation.forEach((_edu: DynamicCandidateProfileComponent, _index) => {
        // edu.form.controls['country_code'].setValue(this.countrycode);
        // edu.form.controls['country_code2'].setValue(this.countrycode2);
        // edu.form.controls['country_code3'].setValue(this.countrycode3);
      });
      this.education.forEach((edu: DynamicCandidateProfileComponent, _index) => {
        // edu.form.controls['country_code'].setValue(this.countrycode);
        // edu.form.controls['country_code2'].setValue(this.countrycode2);
        // edu.form.controls['country_code3'].setValue(this.countrycode3);
        if (!edu.form.valid) {
          tempBool = true;
        }
      });
    } else if (FieldName == 'experience') {
      this.workexperience.forEach((exp: DynamicCandidateProfileComponent, _index) => {
        // exp.form.controls['country_code'].setValue(this.countrycode);
        // exp.form.controls['country_code2'].setValue(this.countrycode2);
        // exp.form.controls['country_code3'].setValue(this.countrycode3);
        if (!exp.form.valid) {
          tempBool = true;
        }
      });
    } else if (FieldName == 'address') {
      this.canAddress.forEach((adr: DynamicCandidateProfileComponent, _index) => {
        // adr.form.controls['country_code'].setValue(this.countrycode);
        // adr.form.controls['country_code2'].setValue(this.countrycode2);
        // adr.form.controls['country_code3'].setValue(this.countrycode3);
        if (!adr.form.valid) {
          tempBool = true;
        }
      });
    } else if (FieldName == 'basic') {
      if (this.dynamicFormComponent.form.invalid) {
        tempBool = true;
      }
    }
    return tempBool;
  }

  downloadApplication(applicationId) {
    this.profile.getFileIds(applicationId, "AP", 3).subscribe(idData => {
      this.profile.downloadFile(idData.id).subscribe(fileData => {
        this.fileDownloadService.downloadFileFromResponse(fileData);
      })
    })
  }

  checkApplication(applicationId) {
    this.profile.getFileIds(applicationId, 'AP', 3).subscribe((idData) => {
      if (idData && idData.id) {
        this.checkApp = true;
      } else {
        this.checkApp = false;
      }
    });
  }

  //Edu Exp section attachment code

  checkEdu(edu, _index) {
    if (edu.fields.find((res) => res.name === 'candidateEducationType').value) {
      const eduTypeVal = edu.fields.find((res) => res.name === 'candidateEducationType').value;
      const canEduType = this.genmodel.educations[0].fields.find((res) => res.name === 'candidateEducationType');
      const tempOptions = canEduType.options.filter((temp) => temp.value != null);
      const canEduId = tempOptions.find((res) => res.value.toLowerCase() === eduTypeVal.toLowerCase());
      const eduTypeId = canEduId.key;
      if (eduTypeId == 8 || eduTypeId == 2 || eduTypeId == 9 || eduTypeId == 7 || eduTypeId == 6) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkExp(exp) {
    if (exp.fields.find((res) => res.name === 'candidateExperienceId').value) {
      return true;
    } else {
      return false;
    }
  }

  hideMainPage(hideStr, expeduVar, index) {
    this.eduExpVar = expeduVar;
    this.targetIndex = index;
    if (expeduVar == 'edu') {
      let eduTypeId;
      console.log(hideStr.fields.find((res) => res.name === 'candidateEducationType').value);
      if (hideStr.fields.find((res) => res.name === 'candidateEducationType').value) {
        const eduForm: DynamicCandidateProfileComponent = this.education['_results'][index];
        const canEduType = this.genmodel.educations[0].fields.find((res) => res.name === 'candidateEducationType');
        const tempOptions = canEduType.options.filter((temp) => temp.value != null);
        const canEduId = tempOptions.find(
          (res) => res.value.toLowerCase() === eduForm.form.get('candidateEducationType').value.toLowerCase(),
        );
        eduTypeId = canEduId.key;
        this.showAttach = true;
      }
      console.log(eduTypeId);

      if (eduTypeId == 9) {
        this.dispAttach = 'X';
      } else if (eduTypeId == 8) {
        this.dispAttach = 'XII';
      } else if (eduTypeId == 7) {
        this.dispAttach = 'grad';
      } else if (eduTypeId == 6) {
        this.dispAttach = 'postGrad';
      } else if (eduTypeId == 2) {
        this.dispAttach = 'diploma';
      }
    }
    if (expeduVar == 'exp') {
      this.experienceForm = [];
      if (this.genmodel.experience) {
        this.workexperience.forEach((exp: DynamicCandidateProfileComponent, _index) => {
          this.expFormInvalid = false;
          const experienceForm = exp.form.value;

          if (exp.form.value.tillDate && (exp.form.value.tillDate == true || exp.form.value.tillDate == 'Y')) {
            experienceForm.tillDate = 'Y';
          } else {
            experienceForm.tillDate = 'N';
          }
          this.experienceForm.push(experienceForm);
        });
      }
      const tempSaveCheck = this.experienceForm.filter((res) => {
        return res != null;
      });
      if (tempSaveCheck.length == this.experienceForm.length) {
        let countExpTill = 0;
        this.experienceForm.forEach((exp) => {
          if (exp['tillDate'] == 'Y') {
            countExpTill++;
          }
        });
        if (countExpTill > 1) {
          this._personaService.openSnackBar(
            { msg: 'Only one Current Employer Allowed', isSuccess: 'error' },
            'danger-snack',
          );
        } else {
          const expForm: DynamicCandidateProfileComponent = this.workexperience['_results'][index];
          console.log(expForm.form.value.tillDate);
          this.candidateExpId = expForm.form.value.candidateExperienceId;
          if (this.candidateExpId) {
            this.apiData.getAllFiles(this.candidateExpId, 'CX').subscribe((res) => {
              this.showAttach = true;
              console.log(res);
              this.attachmentsExpList = res;
              if (expForm.form.value.tillDate == 'Y' || expForm.form.value.tillDate == true) {
                this.dispAttach = 'currentEmp';
              } else {
                this.dispAttach = 'noCurrentEmp';
              }
            });
          }
        }
      }
    }
  }

  showEducation() {
    let target;
    if (this.eduExpVar == 'edu') {
      target = document.getElementById('target-' + this.targetIndex);
    } else if (this.eduExpVar == 'exp') {
      target = document.getElementById('targetExp-' + this.targetIndex);
    }
    setTimeout(() => {
      console.log('!!run');
      target.scrollIntoView();
    }, 200);
    this.showAttach = false;
  }

  selectedType(val: string) {
    this.uploadType = val;
    if (val == 'S') {
      this.semWise = true;
      this.consMark = false;
    } else {
      this.semWise = false;
      this.consMark = true;
    }
  }

  checkFileInserted(dispAttach, index) {
    let attachmentsId;
    switch (dispAttach) {
      case 'X':
        attachmentsId = this.XAttachmentIds[index];
        break;
      case 'XII':
        attachmentsId = this.XIIMarksAttachIds[index];
        break;
      case 'grad':
        if (this.uploadType == 'S') {
          attachmentsId = this.gradSemAttachIds[index];
        } else {
          attachmentsId = this.gradConsAttachIds[index];
        }
        break;
      case 'postGrad':
        if (this.uploadType == 'S') {
          attachmentsId = this.postgradSemAttachIds[index];
        } else {
          attachmentsId = this.postgradConsAttachIds[index];
        }
        break;
      case 'diploma':
        if (this.uploadType == 'S') {
          attachmentsId = this.diplomaSemAttachIds[index];
        } else {
          attachmentsId = this.diplomaConsAttachIds[index];
        }
        break;
      case 'currentEmp':
        attachmentsId = this.currentEmpId[index];
        break;
      case 'noCurrentEmp':
        attachmentsId = this.noCurrentEmpId[index];
        break;
      default:
        break;
    }
    let file;
    if (this.eduExpVar == 'edu') {
      file = this.attachmentsList.find(
        (x) => Number(x.fields.find((res) => res.name === 'attachmentType').options[0].key) == attachmentsId,
      );
    } else {
      file = this.attachmentsExpList.find((x) => x.attachmentId == attachmentsId);
    }
    return file ? true : false;
  }

  customClick(index) {
    const id = 'fileInput-' + index;
    document.getElementById(id).click();
  }

  fileChange(file, dispAttach, fileType?, index?) {
    const lastChunksize = 0;
    const chunkSize = 524288;
    this.fileMergeAttach = [];
    this.eduAtchIndex = index;

    if (this.validate(file)) {
      let attachmentIds;
      switch (dispAttach) {
        case 'X':
          attachmentIds = this.XAttachmentIds[index];
          break;
        case 'XII':
          attachmentIds = this.XIIMarksAttachIds[index];
          break;
        case 'grad':
          if (this.uploadType == 'S') {
            attachmentIds = this.gradSemAttachIds[index];
          } else {
            attachmentIds = this.gradConsAttachIds[index];
          }
          break;
        case 'postGrad':
          if (this.uploadType == 'S') {
            attachmentIds = this.postgradSemAttachIds[index];
          } else {
            attachmentIds = this.postgradConsAttachIds[index];
          }
          break;
        case 'diploma':
          if (this.uploadType == 'S') {
            attachmentIds = this.diplomaSemAttachIds[index];
          } else {
            attachmentIds = this.diplomaConsAttachIds[index];
          }
          break;
        case 'currentEmp':
          attachmentIds = this.currentEmpId[index];
          break;
        case 'noCurrentEmp':
          attachmentIds = this.noCurrentEmpId[index];
          break;
        default:
          break;
      }
      this.eduAttachsIds = attachmentIds;
      console.log(dispAttach, this.dispAttach, index, attachmentIds);
      this.ngxLoader.start();
      this.readFileAttach(file, lastChunksize, this.myCallbackAttach.bind(this), chunkSize);
    }
  }

  validate(file: File) {
    const filenameresp = this.getFileExtension(file.name);
    const fileType = filenameresp ? filenameresp.toLowerCase() : null;
    let fileSizeError;
    if (!fileType) {
      return false;
    } else if (fileType != 'pdf' && fileType != 'jpg' && fileType != 'jpeg') {
      fileSizeError = 'Supported File Formats are JPG,JPEG,and PDF.';
      this._personaService.openSnackBar({ msg: fileSizeError, isSuccess: 'error' }, 'danger-snack');
      return false;
    } else if (file.size > 5242880 && (fileType == 'pdf' || fileType == 'jpg' || fileType == 'jpeg')) {
      fileSizeError = "Let's keep that file size within 5MB.";
      this._personaService.openSnackBar({ msg: fileSizeError, isSuccess: 'error' }, 'danger-snack');
      return false;
    } else if (file.size == 0) {
      fileSizeError = 'Please upload valid file.';
      this._personaService.openSnackBar({ msg: fileSizeError, isSuccess: 'error' }, 'danger-snack');
      return false;
    }
    return true;
  }

  getFileExtension(filename) {
    return filename.split('.').pop();
  }

  readFileAttach(file, lastChunksize: number, callback, chunkSize) {
    const fileBlobRfa_ = file.slice(lastChunksize, lastChunksize + chunkSize);
    if (fileBlobRfa_.size != 0) {
      const fileReaderRfa_ = new FileReader();
      fileReaderRfa_.onloadend = (_result) => {
        this.fileMergeAttach.push(file);
        return callback(file, lastChunksize, fileReaderRfa_.result, chunkSize);
      };
      fileReaderRfa_.readAsText(fileBlobRfa_);
    } else {
      return callback(file, lastChunksize, false);
    }
  }

  myCallbackAttach(file, lastChunksize, result, chunkSize) {
    lastChunksize = lastChunksize + chunkSize;
    if (result) {
      this.readFileAttach(file, lastChunksize, this.myCallbackAttach.bind(this), chunkSize);
    } else {
      //end recursion
      console.log(this.fileMergeAttach[0]);
      if (this.eduExpVar == 'edu') {
        this.fileEduAttachment(
          this.fileMergeAttach[0].name,
          this.fileMergeAttach[0],
          this.eduAttachsIds,
          this.dispAttach,
          this.eduAtchIndex,
        );
      } else if (this.eduExpVar == 'exp') {
        this.fileExpAttachment(
          this.fileMergeAttach[0].name,
          this.fileMergeAttach[0],
          this.eduAttachsIds,
          this.dispAttach,
          this.eduAtchIndex,
        );
      }
    }
  }

  fileEduAttachment(filename, datafile, attachmentId, dispAttach, index) {
    console.log(this.fileMergeAttach[0]);
    console.log(filename, datafile, attachmentId, dispAttach, index);

    const fdFea_ = new FormData();
    fdFea_.append('objectId', this.data.candidateId);
    fdFea_.append('objectType', 'CD');
    fdFea_.append('companyHiringTypeId', this.companyHiringType.toString());
    fdFea_.append('attachmentId', attachmentId);
    fdFea_.append('file[' + filename + ']', datafile);
    console.log(fdFea_);

    this.apiData.uploadImageData(fdFea_).subscribe((dataFea_) => {
      console.log(dataFea_);
      if (dataFea_ && dataFea_['ids']) {
        this.ngxLoader.stop();
        this._personaService.openSnackBar(
          { msg: this.roleCheck ? this.ScsMsgHr : this.ScsMsg, isSuccess: true },
          'success-snack',
        );
        this.apiData.getdata(this.candprofile).subscribe((resFea_) => {
          this.OriginalGenModel = JSON.parse(JSON.stringify(resFea_));
          if (resFea_.attachments) {
            const attchResRea_ = resFea_.attachments.filter((adFieldsRea_) =>
              adFieldsRea_.fields.some((fieldRea_) => fieldRea_.value != null),
            );
            resFea_.attachments = attchResRea_;
            const xAttachRea_ = resFea_.attachments.filter((eleRea_) => {
              const attachIdRea_ = Number(eleRea_.fields.find((field) => field.name === 'attachmentType').options[0].key);
              if (
                this.XAttachmentIds.indexOf(attachIdRea_) != -1 ||
                this.XIIMarksAttachIds.indexOf(attachIdRea_) != -1 ||
                this.gradSemAttachIds.indexOf(attachIdRea_) != -1 ||
                this.gradConsAttachIds.indexOf(attachIdRea_) != -1 ||
                this.postgradSemAttachIds.indexOf(attachIdRea_) != -1 ||
                this.postgradConsAttachIds.indexOf(attachIdRea_) != -1 ||
                this.diplomaSemAttachIds.indexOf(attachIdRea_) != -1 ||
                this.diplomaConsAttachIds.indexOf(attachIdRea_) != -1
              ) {
                return eleRea_;
              }
            });
            resFea_.attachments = xAttachRea_;
            this.attachmentsList = JSON.parse(JSON.stringify(resFea_.attachments));
          }
        });
      }
    },(_err) =>{
      console.log(_err);
      this.ngxLoader.stop();
    });
  }

  downloadOrDeleteAttachment(dispAttach, index, downOrDel) {
    let attachId;
    switch (dispAttach) {
      case 'X':
        attachId = this.XAttachmentIds[index];
        break;
      case 'XII':
        attachId = this.XIIMarksAttachIds[index];
        break;
      case 'grad':
        if (this.uploadType == 'S') {
          attachId = this.gradSemAttachIds[index];
        } else {
          attachId = this.gradConsAttachIds[index];
        }
        break;
      case 'postGrad':
        if (this.uploadType == 'S') {
          attachId = this.postgradSemAttachIds[index];
        } else {
          attachId = this.postgradConsAttachIds[index];
        }
        break;
      case 'diploma':
        if (this.uploadType == 'S') {
          attachId = this.diplomaSemAttachIds[index];
        } else {
          attachId = this.diplomaConsAttachIds[index];
        }
        break;
      default:
        break;
    }
    const file = this.attachmentsList.find(
      (x) => Number(x.fields.find((res) => res.name === 'attachmentType').options[0].key) == attachId,
    );
    console.log(file);

    const attachBrowse = file.fields.find((res) => res.name == 'attachmentBrowse');
    console.log(attachBrowse);

    this.downLoadFileData(attachBrowse, downOrDel);
  }

  downLoadFileData(file, downOrDel) {
    this.http.get<any>(file.url).subscribe((fileres) => {
      console.log(fileres);
      if (downOrDel == 'Download') {
        const fileData = fileres;
        let mimeType = '';
        let fileTypedwld_ = '';
        if (!fileData.fileType.startsWith('.')) {
          fileTypedwld_ = '.' + fileData.fileType;
        } else {
          fileTypedwld_ = fileData.fileType;
        }
        switch (fileTypedwld_) {
          case '.pdf': {
            mimeType = 'pdf';
            break;
          }
          case '.docx': {
            mimeType = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
            break;
          }
          case '.doc': {
            mimeType = 'msword';
            break;
          }
          case '.jpg': {
            mimeType = 'jpeg';
            break;
          }
          case '.jpeg': {
            mimeType = 'jpeg';
            break;
          }
          case '.png': {
            mimeType = 'png';
          }
        }

        const arrBuffer = this.base64ToArrayBuffer(fileData.file.data);
        let newBlob;
        if (mimeType == 'png' || mimeType == 'jpeg') {
          newBlob = new Blob([arrBuffer], { type: 'image/' + mimeType });
        } else {
          newBlob = new Blob([arrBuffer], { type: 'application/' + mimeType });
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        document.body.appendChild(link);
        link.href = data;
        // link.download = fileName;
        link.download = fileData.fileName.replace('.', '_');
        link.click();
        window.URL.revokeObjectURL(data);
        link.remove();
      } else if (downOrDel == 'Delete') {
        const messageReject = 'Are you sure you want to delete this Attachment ?';
        const dialogData = new ConfirmDialogModel(messageReject, '');
        const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
        dialogRef.afterClosed().subscribe((dialogResultReject) => {
          if (dialogResultReject) {
            const fileId = fileres.fileId;
            this.apiData.deleteFile(fileId).subscribe((res) => {
              console.log(res);
              this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
              this.apiData.getdata(this.candprofile).subscribe((res) => {
                this.OriginalGenModel = JSON.parse(JSON.stringify(res));
                if (res.attachments) {
                  const attchResGtd_ = res.attachments.filter((adFieldsAtch_) =>
                    adFieldsAtch_.fields.some((fieldAtch_) => fieldAtch_.value != null),
                  );
                  res.attachments = attchResGtd_;
                }
                const xAttach = res.attachments.filter((ele) => {
                  const attachId = Number(ele.fields.find((field) => field.name === 'attachmentType').options[0].key);
                  if (
                    this.XAttachmentIds.indexOf(attachId) != -1 ||
                    this.XIIMarksAttachIds.indexOf(attachId) != -1 ||
                    this.gradSemAttachIds.indexOf(attachId) != -1 ||
                    this.gradConsAttachIds.indexOf(attachId) != -1 ||
                    this.postgradSemAttachIds.indexOf(attachId) != -1 ||
                    this.postgradConsAttachIds.indexOf(attachId) != -1 ||
                    this.diplomaSemAttachIds.indexOf(attachId) != -1 ||
                    this.diplomaConsAttachIds.indexOf(attachId) != -1
                  ) {
                    return ele;
                  }
                });
                res.attachments = xAttach;
                this.attachmentsList = JSON.parse(JSON.stringify(res.attachments));
              });
            });
          }
        });
      }
    });
  }

  base64ToArrayBuffer(data) {
    const binaryString = window.atob(data);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  fileExpAttachment(filename, datafile, attachmentId, _dispAttach, _index) {
    const fdFda_ = new FormData();
    fdFda_.append('objectId', this.candidateExpId);
    fdFda_.append('objectType', 'CX');
    fdFda_.append('companyHiringTypeId', this.companyHiringType.toString());
    fdFda_.append('attachmentId', attachmentId);
    fdFda_.append('file[' + filename + ']', datafile);
    console.log(fdFda_);

    this.apiData.uploadImageData(fdFda_).subscribe((data) => {
      console.log(data);
      if (data && data['ids']) {
        this.ngxLoader.stop();
        this._personaService.openSnackBar(
          { msg: this.roleCheck ? this.ScsMsgHr : this.ScsMsg, isSuccess: true },
          'success-snack',
        );
        if (this.candidateExpId) {
          this.apiData.getAllFiles(this.candidateExpId, 'CX').subscribe((res) => {
            console.log(res);
            this.attachmentsExpList = res;
          });
        }
      }
    },(_err) =>{
      console.log(_err);
      this.ngxLoader.stop();
    });
  }

  downloadOrDeleteExpAttachment(dispAttach, index, downOrDel) {
    let attachId;
    switch (dispAttach) {
      case 'currentEmp':
        attachId = this.currentEmpId[index];
        break;
      case 'noCurrentEmp':
        attachId = this.noCurrentEmpId[index];
        break;
      default:
        break;
    }
    const file = this.attachmentsExpList.find((x) => x.attachmentId == attachId);
    if (downOrDel == 'Download') {
      let mimeType = '';
      let fileType = '';
      if (!file.fileType.startsWith('.')) {
        fileType = '.' + file.fileType;
      } else {
        fileType = file.fileType;
      }
      switch (fileType) {
        case '.pdf': {
          mimeType = 'pdf';
          break;
        }
        case '.docx': {
          mimeType = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        }
        case '.doc': {
          mimeType = 'msword';
          break;
        }
        case '.jpg': {
          mimeType = 'jpeg';
          break;
        }
        case '.jpeg': {
          mimeType = 'jpeg';
          break;
        }
        case '.png': {
          mimeType = 'png';
        }
      }

      const fileName = file.fileName + '' + fileType;

      const arrBuffer = this.base64ToArrayBuffer(file.file);
      let newBlob;
      if (mimeType == 'png' || mimeType == 'jpeg') {
        newBlob = new Blob([arrBuffer], { type: 'image/' + mimeType });
      } else {
        newBlob = new Blob([arrBuffer], { type: 'application/' + mimeType });
      }
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      document.body.appendChild(link);
      link.href = data;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(data);
      link.remove();
    } else if (downOrDel == 'Delete') {
      const messageReject = 'Are you sure you want to delete this Attachment ?';
      const dialogData = new ConfirmDialogModel(messageReject, '');
      const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
      dialogRef.afterClosed().subscribe((dialogResultReject) => {
        if (dialogResultReject) {
          const fileId = file.fileId;
          this.apiData.deleteFile(fileId).subscribe((res) => {
            console.log(res);
            this._personaService.openSnackBar({ msg: 'Deleted Successfully', isSuccess: true }, 'success-snack');
            if (this.candidateExpId) {
              this.apiData.getAllFiles(this.candidateExpId, 'CX').subscribe((res) => {
                console.log(res);
                this.attachmentsExpList = res;
              });
            }
          });
        }
      });
    }
  }

  hasExperienceOverlap(experiences: any[]) {
    const dateRanges = experiences
      .filter((exp) => exp.joinedDate && exp.bgVerification == 'Y')
      .map((exp) => {
        const fromDate = new Date(exp.joinedDate);
        const toDate = exp.currentEmployer === 'Y' ? new Date() : exp.leftDate ? new Date(exp.leftDate) : new Date();
        let organizationName = '';
        if (exp.organizationId) {
          const organization = this.genmodel.experience[0].fields.find((res) => res.name === 'currentEmployer');
          organizationName = organization.options.find((opt) => opt.key === exp.organizationId)?.value;
        }

        const companyName = exp.organizationName ? exp.organizationName : organizationName;
        return { fromDate, toDate, exp, companyName };
      });

    for (let i = 0; i < dateRanges.length; i++) {
      for (let j = i + 1; j < dateRanges.length; j++) {
        const range1 = dateRanges[i];
        const range2 = dateRanges[j];

        if (
          moment(range1.fromDate).isSameOrBefore(moment(range2.toDate), 'day') &&
          moment(range1.toDate).isSameOrAfter(moment(range2.fromDate), 'day')
        ) {
          return {
            company1: range1.companyName,
            company2: range2.companyName,
          };
        }
      }
    }

    return null;
  }

  hasEducationOverlap(educations: any[]) {
    const dateRanges = educations
      .filter((edu) => edu.startDate && edu.endDate)
      .map((edu) => {
        const fromDate = new Date(edu.startDate);
        const toDate = new Date(edu.endDate);
        return { fromDate, toDate, edu };
      });

    dateRanges.sort((a, b) => a.fromDate.getTime() - b.fromDate.getTime());

    for (let i = 0; i < dateRanges.length - 1; i++) {
      const current = dateRanges[i];
      const next = dateRanges[i + 1];

      // If current range ends after next range starts, there is an overlap
      if (current.toDate > next.fromDate) {
        return {
          candidateEducationType1: current.edu.educationTypeName,
          candidateEducationType2: next.edu.educationTypeName,
        };
      }
    }

    return null;
  }

  educationDupDegreeCheck(educForm) {
    let dupBool = false;
    let education1Name = '';
    let education2Name = '';
    for (let i = 0; i < educForm.length; i++) {
      for (let j = i + 1; j < educForm.length; j++) {
        if (educForm[i].degreeId && educForm[j].degreeId && educForm[i].degreeId == educForm[j].degreeId) {
          education1Name = educForm[i].educationTypeName ? educForm[i].educationTypeName : '';
          education2Name = educForm[j].educationTypeName ? educForm[j].educationTypeName : '';
          dupBool = true;
          break;
        }
      }
    }
    return {
      isDuplicate: dupBool,
      education1Name: education1Name,
      education2Name: education2Name,
    };
  }

  //   educationDupSpecializationCheck(educForm){
  //   let dupBool = false;
  //   for(let i = 0; i< educForm.length; i++){
  //     for(let j = i+1; j< educForm.length; j++){
  //       if((educForm[i].specializationId == educForm[j].specializationId)){
  //         dupBool = true;
  //         break;
  //       }
  //     }
  //   }
  //   return dupBool;
  // }

  educationDupCheck(educForm) {
    let dupBool = false;
    for (let i = 0; i < educForm.length; i++) {
      for (let j = i + 1; j < educForm.length; j++) {
        if (
          educForm[i].degreeId &&
          educForm[j].degreeId &&
          educForm[i].specializationId &&
          educForm[j].specializationId &&
          educForm[i].degreeName &&
          educForm[j].degreeName &&
          educForm[i].specializationName &&
          educForm[j].specializationName &&
          (educForm[i].degreeId == educForm[j].degreeId || educForm[i].degreeName == educForm[j].degreeName) &&
          (educForm[i].specializationId == educForm[j].specializationId ||
            educForm[i].specializationName == educForm[j].specializationName)
        ) {
          dupBool = true;
          break;
        }
      }
    }
    return dupBool;
  }
}
